"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[274],{

/***/ 28635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ TrendingTimeFrame; }
/* harmony export */ });
var TrendingTimeFrame;
(function(TrendingTimeFrame) {
    TrendingTimeFrame["ALL"] = "TIME_FRAME_ALL";
    TrendingTimeFrame["ONE_WEEK"] = "TIME_FRAME_1W";
    TrendingTimeFrame["ONE_MONTH"] = "TIME_FRAME_1M";
})(TrendingTimeFrame || (TrendingTimeFrame = {}));


/***/ }),

/***/ 79030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C1": function() { return /* binding */ MAX_FILE_SIZE_MB; },
/* harmony export */   "EZ": function() { return /* binding */ IMAGE_TYPE_COMMON; },
/* harmony export */   "Jo": function() { return /* binding */ MAX_IMAGE_SIZE_MB; },
/* harmony export */   "Tb": function() { return /* binding */ MAX_FILE_SIZE; },
/* harmony export */   "Wk": function() { return /* binding */ initialTargetPrice; },
/* harmony export */   "ZX": function() { return /* binding */ COMPOSE_MODE; },
/* harmony export */   "fg": function() { return /* binding */ initialPolling; },
/* harmony export */   "l2": function() { return /* binding */ COMMENT_SETTING_LIST; },
/* harmony export */   "n0": function() { return /* binding */ MAX_IMAGE_SIZE; },
/* harmony export */   "ox": function() { return /* binding */ ALLOWED_DOC_EXT; },
/* harmony export */   "p$": function() { return /* binding */ IMAGE_TYPE_GIF; },
/* harmony export */   "vS": function() { return /* binding */ ADMIN_USER_PRIVILEGE; }
/* harmony export */ });
var ALLOWED_DOC_EXT = [
    ".pdf",
    ".doc",
    ".docx",
    ".xls",
    ".xlsx",
    ".ppt",
    ".pptx",
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-powerpointtd",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation", 
];
// max file size: 0MB
var MAX_FILE_SIZE_MB = 10;
var MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;
var MAX_IMAGE_SIZE_MB = 2;
var MAX_IMAGE_SIZE = MAX_IMAGE_SIZE_MB * 1024 * 1024;
var COMPOSE_MODE = {
    COMPOSE: "compose",
    EDIT: "edit",
    REPOST: "repost",
    SHARE: "share",
    SHARE_TEXT: "share-link"
};
var initialPolling = {
    isOpen: false,
    duration: {
        Days: 1,
        Hours: 0,
        Mins: 0
    },
    polling_pin: 0,
    polling_options: [
        {
            id: 1,
            value: ""
        },
        {
            id: 2,
            value: ""
        }, 
    ],
    polling_end: 0
};
var initialTargetPrice = {
    isOpen: false,
    target_duration: "7",
    target_price: 0,
    target_symbol: ""
};
var IMAGE_TYPE_GIF = "GIF";
var IMAGE_TYPE_COMMON = "COMMON";
var COMMENT_SETTING_LIST = [
    {
        id: 1,
        label: "Everyone",
        type: "COMMENTER_TYPE_EVERYONE",
        icon: "comment-globe.svg"
    },
    {
        id: 2,
        label: "Only people you follow",
        type: "COMMENTER_TYPE_FOLLOWING",
        icon: "comment-people.svg"
    },
    {
        id: 3,
        label: "Only people you mention",
        type: "COMMENTER_TYPE_MENTION",
        icon: "comment-mention.svg"
    },
    {
        id: 4,
        label: "Only you",
        type: "COMMENTER_TYPE_ONLY_YOU",
        icon: "comment-private.svg"
    }, 
];
var ADMIN_USER_PRIVILEGE = [
    "1",
    "2",
    "4"
];



/***/ }),

/***/ 41351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BT": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_REPORT; },
/* harmony export */   "D6": function() { return /* binding */ DATA_CY_USER_CATEGORY_IDEAS; },
/* harmony export */   "EJ": function() { return /* binding */ DATA_CY_NAME_NEWS_HEADER_MENU; },
/* harmony export */   "En": function() { return /* binding */ DATA_CY_USER_CATEGORY_CHARTS; },
/* harmony export */   "Js": function() { return /* binding */ DATA_CY_DROPDOWN_STREAM_TYPE_ALL; },
/* harmony export */   "LO": function() { return /* binding */ DATA_CY_USER_CATEGORY_SAVED; },
/* harmony export */   "MF": function() { return /* binding */ DATA_CY_DROPDOWN_STREAM_ACTIVE; },
/* harmony export */   "Me": function() { return /* binding */ DATA_CY_USER_CATEGORY_LIKED; },
/* harmony export */   "N5": function() { return /* binding */ DATA_CY_DROPDOWN_STREAM_TYPE_TRENDING; },
/* harmony export */   "Nd": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_POLLING_COMPANY; },
/* harmony export */   "OR": function() { return /* binding */ DATA_CY_DROPDOWN_STREAM_TYPE_FOLLOWED; },
/* harmony export */   "Ox": function() { return /* binding */ DATA_CY_SEARCH_STREAM_FILTER_FROM; },
/* harmony export */   "Ps": function() { return /* binding */ DATA_CY_DROPDOWN_STREAM_TYPE_ALL_COMPANY; },
/* harmony export */   "SP": function() { return /* binding */ DATA_CY_USER_CATEGORY_NOTES; },
/* harmony export */   "Tb": function() { return /* binding */ DATA_CY_NAME_NOTES_MENU_COMPANY; },
/* harmony export */   "UL": function() { return /* binding */ DATA_CY_SEARCH_STREAM_MENU_SEARCH; },
/* harmony export */   "Ys": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_PREDICTION; },
/* harmony export */   "Zl": function() { return /* binding */ DATA_CY_NAME_STREAM_HEADER_MENU; },
/* harmony export */   "_t": function() { return /* binding */ DATA_CY_NAME_RESEARCH_HEADER_MENU; },
/* harmony export */   "b7": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_INSIDER_COMPANY; },
/* harmony export */   "bJ": function() { return /* binding */ DATA_CY_SEARCH_STREAM_FILTER_TO; },
/* harmony export */   "c6": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_CHART_COMPANY; },
/* harmony export */   "dV": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_INSIDER; },
/* harmony export */   "ed": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_POLLING; },
/* harmony export */   "gJ": function() { return /* binding */ DATA_CY_DROPDOWN_STREAM_TYPE_WATCHLIST; },
/* harmony export */   "gz": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_REPORT_COMPANY; },
/* harmony export */   "h$": function() { return /* binding */ DATA_CY_SEARCH_STREAM_SUBMIT; },
/* harmony export */   "hL": function() { return /* binding */ DATA_CY_SEARCH_STREAM_MENU; },
/* harmony export */   "je": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_IDEA; },
/* harmony export */   "kk": function() { return /* binding */ DATA_CY_NAME_NEWS_HEADER_MENU_COMPANY; },
/* harmony export */   "lJ": function() { return /* binding */ DATA_CY_DROPDOWN_STREAM_TYPE_PEOPLE; },
/* harmony export */   "p2": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_IDEA_COMPANY; },
/* harmony export */   "sQ": function() { return /* binding */ DATA_CY_NAME_RESEARCH_HEADER_MENU_COMPANY; },
/* harmony export */   "tG": function() { return /* binding */ DATA_CY_USER_CATEGORY_REPLIES; },
/* harmony export */   "tx": function() { return /* binding */ DATA_CY_SEARCH_STREAM_MENU_FILTER; },
/* harmony export */   "v6": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_CHART; },
/* harmony export */   "wv": function() { return /* binding */ DATA_CY_NAME_STREAM_SUB_HEADER_PREDICTION_COMPANY; },
/* harmony export */   "xB": function() { return /* binding */ DATA_CY_DROPDOWN_STREAM_REPORT_ACTIVE; },
/* harmony export */   "zc": function() { return /* binding */ DATA_CY_USER_CATEGORY_PREDICTIONS; }
/* harmony export */ });
/* unused harmony exports DATA_CY_NAME_STREAM_HEADER_MENU_COMPANY, DATA_CY_SEARCH_STREAM_MENU_FILTER_COMPANY, DATA_CY_SEARCH_STREAM_MENU_SEARCH_COMPANY, DATA_CY_SEARCH_STREAM_FILTER_FROM_COMPANY, DATA_CY_SEARCH_STREAM_FILTER_TO_COMPANY, DATA_CY_SEARCH_STREAM_SUBMIT_COMPANY, DATA_CY_DROPDOWN_STREAM_TYPE_TRENDING_COMPANY, DATA_CY_DROPDOWN_STREAM_TYPE_FOLLOWED_COMPANY, DATA_CY_DROPDOWN_STREAM_TYPE_PEOPLE_COMPANY, DATA_CY_DROPDOWN_STREAM_TYPE_WATCHLIST_COMPANY */
var DATA_CY_NAME_STREAM_HEADER_MENU = "stream-header-menu";
var DATA_CY_NAME_STREAM_SUB_HEADER_IDEA = "stream-sub-header-idea";
var DATA_CY_NAME_STREAM_SUB_HEADER_REPORT = "stream-sub-header-reports";
var DATA_CY_NAME_STREAM_SUB_HEADER_PREDICTION = "stream-sub-header-predictions";
var DATA_CY_NAME_STREAM_SUB_HEADER_POLLING = "stream-sub-header-polling";
var DATA_CY_NAME_STREAM_SUB_HEADER_INSIDER = "stream-sub-header-insiders";
var DATA_CY_NAME_STREAM_SUB_HEADER_CHART = "stream-sub-header-charts";
var DATA_CY_NAME_NEWS_HEADER_MENU = "news-header-menu";
var DATA_CY_NAME_RESEARCH_HEADER_MENU = "research-header-menu";
var DATA_CY_SEARCH_STREAM_MENU_FILTER = "search-stream-menu-filter";
var DATA_CY_SEARCH_STREAM_MENU = "search-stream-menu";
var DATA_CY_SEARCH_STREAM_MENU_SEARCH = "search-stream-menu-search";
var DATA_CY_SEARCH_STREAM_FILTER_FROM = "search-stream-filter-from";
var DATA_CY_SEARCH_STREAM_FILTER_TO = "search-stream-filter-to";
var DATA_CY_SEARCH_STREAM_SUBMIT = "search-stream-submit";
var DATA_CY_DROPDOWN_STREAM_ACTIVE = "dropdown-stream-active";
var DATA_CY_DROPDOWN_STREAM_TYPE_ALL = "dropdown-stream-type-all";
var DATA_CY_DROPDOWN_STREAM_TYPE_TRENDING = "dropdown-stream-type-trending";
var DATA_CY_DROPDOWN_STREAM_TYPE_FOLLOWED = "dropdown-stream-type-followed";
var DATA_CY_DROPDOWN_STREAM_TYPE_PEOPLE = "dropdown-stream-type-people";
var DATA_CY_DROPDOWN_STREAM_TYPE_WATCHLIST = "dropdown-stream-type-watchlist";
var DATA_CY_NAME_STREAM_HEADER_MENU_COMPANY = "stream-header-menu-company";
var DATA_CY_NAME_STREAM_SUB_HEADER_IDEA_COMPANY = "stream-sub-header-idea-company";
var DATA_CY_NAME_STREAM_SUB_HEADER_REPORT_COMPANY = "stream-sub-header-reports-company";
var DATA_CY_NAME_STREAM_SUB_HEADER_PREDICTION_COMPANY = "stream-sub-header-predictions-company";
var DATA_CY_NAME_STREAM_SUB_HEADER_POLLING_COMPANY = "stream-sub-header-polling-company";
var DATA_CY_NAME_STREAM_SUB_HEADER_INSIDER_COMPANY = "stream-sub-header-insiders-company";
var DATA_CY_NAME_STREAM_SUB_HEADER_CHART_COMPANY = "stream-sub-header-charts-company";
var DATA_CY_NAME_NEWS_HEADER_MENU_COMPANY = "news-header-menu-company";
var DATA_CY_NAME_NOTES_MENU_COMPANY = "stream-notes-compose-company";
var DATA_CY_NAME_RESEARCH_HEADER_MENU_COMPANY = "research-header-menu-company";
var DATA_CY_SEARCH_STREAM_MENU_FILTER_COMPANY = "search-stream-menu-filter-company";
var DATA_CY_SEARCH_STREAM_MENU_SEARCH_COMPANY = "search-stream-menu-search-company";
var DATA_CY_SEARCH_STREAM_FILTER_FROM_COMPANY = "search-stream-filter-from-company";
var DATA_CY_SEARCH_STREAM_FILTER_TO_COMPANY = "search-stream-filter-to-company";
var DATA_CY_SEARCH_STREAM_SUBMIT_COMPANY = "search-stream-submit-company";
var DATA_CY_DROPDOWN_STREAM_TYPE_ALL_COMPANY = "dropdown-stream-type-all-company";
var DATA_CY_DROPDOWN_STREAM_TYPE_TRENDING_COMPANY = "dropdown-stream-type-trending-company";
var DATA_CY_DROPDOWN_STREAM_TYPE_FOLLOWED_COMPANY = "dropdown-stream-type-followed-company";
var DATA_CY_DROPDOWN_STREAM_TYPE_PEOPLE_COMPANY = "dropdown-stream-type-people-company";
var DATA_CY_DROPDOWN_STREAM_TYPE_WATCHLIST_COMPANY = "dropdown-stream-type-watchlist-company";
var DATA_CY_DROPDOWN_STREAM_REPORT_ACTIVE = "dropdown-stream-report-active";
var DATA_CY_USER_CATEGORY_IDEAS = "user-category-ideas";
var DATA_CY_USER_CATEGORY_REPLIES = "user-category-replies";
var DATA_CY_USER_CATEGORY_CHARTS = "user-category-charts";
var DATA_CY_USER_CATEGORY_LIKED = "user-category-liked";
var DATA_CY_USER_CATEGORY_SAVED = "user-category-saved";
var DATA_CY_USER_CATEGORY_PREDICTIONS = "user-category-predictions";
var DATA_CY_USER_CATEGORY_NOTES = "user-category-notes";


/***/ }),

/***/ 21390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DY": function() { return /* binding */ TAB_USER_CATEGORIES; },
/* harmony export */   "Hw": function() { return /* binding */ nonSourceNews; },
/* harmony export */   "J1": function() { return /* binding */ streamTypes; },
/* harmony export */   "OW": function() { return /* binding */ STREAM_REPORT; },
/* harmony export */   "R5": function() { return /* binding */ STREAM_TYPE; },
/* harmony export */   "Sb": function() { return /* binding */ DEFAULT_TYPE; },
/* harmony export */   "U1": function() { return /* binding */ reportCategories; },
/* harmony export */   "Z9": function() { return /* binding */ DEFAULT_HEADER; },
/* harmony export */   "bd": function() { return /* binding */ categories; },
/* harmony export */   "c$": function() { return /* binding */ reportOptions; },
/* harmony export */   "cT": function() { return /* binding */ stockChange; },
/* harmony export */   "eB": function() { return /* binding */ STREAM_STATE; },
/* harmony export */   "gd": function() { return /* binding */ MAX_TIPPING_AMOUNT; },
/* harmony export */   "hD": function() { return /* binding */ STREAM_VERSION; },
/* harmony export */   "oE": function() { return /* binding */ LS_STREAM_TRENDING_TAB_DATE; },
/* harmony export */   "oK": function() { return /* binding */ TAB_CATEGORIES; },
/* harmony export */   "q1": function() { return /* binding */ STREAM_TABS; }
/* harmony export */ });
/* unused harmony exports STREAM_CATEGORY_ENUM, STREAM_REPORT_TYPE_ENUM */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76825);
/* harmony import */ var _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41351);



var STREAM_TYPE = {
    GENERIC: "generic",
    USER: "user",
    SYMBOL: "symbol"
};
var genericCategories = [
    {
        label: "Ideas",
        key: "ideas",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_IDEA */ .je
    },
    {
        label: "Reports",
        key: "reports",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_REPORT */ .BT
    },
    {
        label: "Predictions",
        key: "predictions",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_PREDICTION */ .Ys
    },
    {
        label: "Polling",
        key: "pollings",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_POLLING */ .ed
    },
    {
        label: "Insiders",
        key: "insider",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_INSIDER */ .dV
    },
    {
        label: "Charts",
        key: "charts",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_CHART */ .v6
    }, 
];
var symbolCategories = [
    {
        label: "All",
        key: "all",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_DROPDOWN_STREAM_TYPE_ALL_COMPANY */ .Ps
    },
    {
        label: "Notes",
        key: "notes",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_NOTES_MENU_COMPANY */ .Tb
    },
    {
        label: "News",
        key: "news",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_NEWS_HEADER_MENU_COMPANY */ .kk
    },
    {
        label: "Reports",
        key: "reports",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_REPORT_COMPANY */ .gz
    },
    {
        label: "Research",
        key: "research",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_RESEARCH_HEADER_MENU_COMPANY */ .sQ
    },
    {
        label: "Ideas",
        key: "ideas",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_IDEA_COMPANY */ .p2
    },
    {
        label: "Predictions",
        key: "predictions",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_PREDICTION_COMPANY */ .wv
    },
    {
        label: "Polling",
        key: "pollings",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_POLLING_COMPANY */ .Nd
    },
    {
        label: "Insiders",
        key: "insider",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_INSIDER_COMPANY */ .b7
    },
    {
        label: "Charts",
        key: "charts",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_SUB_HEADER_CHART_COMPANY */ .c6
    }, 
];
var userCategories = [
    {
        label: "Ideas",
        key: "main ideas",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_USER_CATEGORY_IDEAS */ .D6
    },
    {
        label: "Notes",
        key: "notes",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_USER_CATEGORY_NOTES */ .SP
    },
    {
        label: "Replies",
        key: "reply",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_USER_CATEGORY_REPLIES */ .tG
    },
    {
        label: "Charts",
        key: "charts",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_USER_CATEGORY_CHARTS */ .En
    },
    {
        label: "Liked",
        key: "liked",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_USER_CATEGORY_LIKED */ .Me
    },
    {
        label: "Saved",
        key: "saved",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_USER_CATEGORY_SAVED */ .LO
    },
    {
        label: "Predictions",
        key: "predictions",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_USER_CATEGORY_PREDICTIONS */ .zc
    }, 
];
var _obj;
var categories = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, STREAM_TYPE.GENERIC, genericCategories), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, STREAM_TYPE.SYMBOL, symbolCategories), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, STREAM_TYPE.USER, userCategories), _obj);
var streamTypes = [
    {
        label: "Trending",
        key: "trending",
        lsKey: "trending",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_DROPDOWN_STREAM_TYPE_TRENDING */ .N5
    },
    {
        label: "Followed",
        key: "all watchlist",
        lsKey: "following",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_DROPDOWN_STREAM_TYPE_FOLLOWED */ .OR
    },
    {
        label: "All",
        key: "latest",
        lsKey: "latest",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_DROPDOWN_STREAM_TYPE_ALL */ .Js
    },
    {
        label: "People",
        key: "people watchlist",
        lsKey: "following_people",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_DROPDOWN_STREAM_TYPE_PEOPLE */ .lJ
    },
    {
        label: "Watchlist",
        key: "company watchlist",
        lsKey: "following_company",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_DROPDOWN_STREAM_TYPE_WATCHLIST */ .gJ
    }, 
];
var reportCategories = [
    {
        label: "All",
        key: "all"
    },
    {
        label: "Laporan Keuangan",
        key: "laporan_keuangan"
    },
    {
        label: "RUPS/Public Expose",
        key: "rups"
    },
    {
        label: "Kepemilikan Saham",
        key: "kepemilikan_saham"
    },
    {
        label: "Dividend",
        key: "dividend"
    },
    {
        label: "Corporate Action",
        key: "corporate_action"
    },
    {
        label: "Others",
        key: "others"
    }, 
];
var reportOptions = [
    {
        key: "1",
        label: "Improper Use of $ Tag"
    },
    {
        key: "2",
        label: "Incorrect Writing Standard"
    },
    {
        key: "3",
        label: "Advertising"
    },
    {
        key: "4",
        label: "Junk Post"
    },
    {
        key: "5",
        label: "Spam"
    },
    {
        key: "6",
        label: "Out of Topic"
    },
    {
        key: "7",
        label: "Vulgarity"
    },
    {
        key: "8",
        label: "Abusive Behaviour"
    },
    {
        key: "9",
        label: "Provoking Other Users"
    },
    {
        key: "10",
        label: "Inapropriate Username & Photo"
    },
    {
        key: "11",
        label: "Stocks Cheering"
    }, 
];
var stockChange = {
    netral: {
        icon: "",
        color: _stockbit_ui__WEBPACK_IMPORTED_MODULE_0__/* .color.nobel */ .$_.nobel
    },
    up: {
        icon: "icon-symbol_up",
        color: _stockbit_ui__WEBPACK_IMPORTED_MODULE_0__/* .color.primary */ .$_.primary
    },
    down: {
        icon: "icon-symbol_down",
        color: _stockbit_ui__WEBPACK_IMPORTED_MODULE_0__/* .color.sunsetOrange */ .$_.sunsetOrange
    }
};
var STREAM_STATE = {
    CATEGORY: "stbx-active-stream-filter",
    TYPE: "stbx-active-stream",
    TAB: "stbx-active-stream-header"
};
var nonSourceNews = {
    stockbitnews: {
        username: "StockbitNews",
        label: "Stockbit News",
        extend: true,
        image: "/img/sbnewsicon.png"
    },
    klsenews: {
        username: "KLSEnews",
        label: "KLSENews",
        extend: false,
        image: "/img/sbnewsicon.png"
    }
};
var STREAM_TABS = [
    {
        label: "Stream",
        value: "stream",
        icon: "/icon/stream-filter/header-stream",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_STREAM_HEADER_MENU */ .Zl
    },
    {
        label: "News",
        value: "news",
        icon: "/icon/stream-filter/header-news",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_NEWS_HEADER_MENU */ .EJ
    },
    {
        label: "Research",
        value: "research",
        icon: "/icon/stream-filter/header-research",
        dataCy: _Navigation_NavigationTab_tests_constant__WEBPACK_IMPORTED_MODULE_1__/* .DATA_CY_NAME_RESEARCH_HEADER_MENU */ ._t
    }, 
];
var DEFAULT_TYPE = "ideas";
var DEFAULT_HEADER = "stream";
var MAX_TIPPING_AMOUNT = 10000000;
var LS_STREAM_TRENDING_TAB_DATE = "stbx-active-trending-date";
// Constants for stream v3 (general, company, user)
var STREAM_VERSION = {
    DEFAULT: "exodus",
    V3: "exodus_v3"
};
var STREAM_CATEGORY_ENUM = {
    ALL: "STREAM_CATEGORY_ALL",
    ALL_WATCHLIST: "STREAM_CATEGORY_ALL_WATCHLIST",
    PEOPLE_WATCHLIST: "STREAM_CATEGORY_PEOPLE_WATCHLIST",
    COMPANY_WATCHLIST: "STREAM_CATEGORY_COMPANY_WATCHLIST",
    NEWS: "STREAM_CATEGORY_NEWS",
    CHART: "STREAM_CATEGORY_CHART",
    CHARTS: "STREAM_CATEGORY_CHART",
    REPORTS: "STREAM_CATEGORY_REPORTS",
    IDEAS: "STREAM_CATEGORY_IDEAS",
    INSIDER: "STREAM_CATEGORY_INSIDER",
    PREDICTION: "STREAM_CATEGORY_PREDICTION",
    PREDICTIONS: "STREAM_CATEGORY_PREDICTION",
    POLLING: "STREAM_CATEGORY_POLLING",
    POLLINGS: "STREAM_CATEGORY_POLLING",
    REPLY: "STREAM_CATEGORY_REPLY",
    MAIN_IDEAS: "STREAM_CATEGORY_MAIN_IDEAS",
    LIKED: "STREAM_CATEGORY_LIKED",
    SAVED: "STREAM_CATEGORY_SAVED",
    RESEARCH: "research"
};
var TAB_CATEGORIES = {
    all: STREAM_CATEGORY_ENUM.ALL,
    ideas: STREAM_CATEGORY_ENUM.IDEAS,
    news: STREAM_CATEGORY_ENUM.NEWS,
    reports: STREAM_CATEGORY_ENUM.REPORTS,
    charts: STREAM_CATEGORY_ENUM.CHART,
    insider: STREAM_CATEGORY_ENUM.INSIDER,
    predictions: STREAM_CATEGORY_ENUM.PREDICTION,
    pollings: STREAM_CATEGORY_ENUM.POLLING,
    latest: STREAM_CATEGORY_ENUM.IDEAS,
    "all watchlist": STREAM_CATEGORY_ENUM.ALL_WATCHLIST,
    "people watchlist": STREAM_CATEGORY_ENUM.PEOPLE_WATCHLIST,
    "company watchlist": STREAM_CATEGORY_ENUM.COMPANY_WATCHLIST
};
var TAB_USER_CATEGORIES = {
    "main ideas": STREAM_CATEGORY_ENUM.MAIN_IDEAS,
    reply: STREAM_CATEGORY_ENUM.REPLY,
    charts: STREAM_CATEGORY_ENUM.CHART,
    liked: STREAM_CATEGORY_ENUM.LIKED,
    saved: STREAM_CATEGORY_ENUM.SAVED,
    predictions: STREAM_CATEGORY_ENUM.PREDICTIONS
};
var STREAM_REPORT_TYPE_ENUM = {
    OTHER: "REPORT_TYPE_OTHER",
    LAPORAN_KEUANGAN: "REPORT_TYPE_LAPORAN_KEUANGAN",
    RUPS: "REPORT_TYPE_RUPS",
    KEPIMILIKAN_SAHAM: "REPORT_TYPE_KEPIMILIKAN_SAHAM",
    DIVIDEN: "REPORT_TYPE_DIVIDEN",
    CORPORATE_ACTION: "REPORT_TYPE_CORPORATE_ACTION",
    ALL: "REPORT_TYPE_ALL"
};
var STREAM_REPORT = {
    all: STREAM_REPORT_TYPE_ENUM.ALL,
    laporan_keuangan: STREAM_REPORT_TYPE_ENUM.LAPORAN_KEUANGAN,
    rups: STREAM_REPORT_TYPE_ENUM.RUPS,
    kepemilikan_saham: STREAM_REPORT_TYPE_ENUM.KEPIMILIKAN_SAHAM,
    dividend: STREAM_REPORT_TYPE_ENUM.DIVIDEN,
    corporate_action: STREAM_REPORT_TYPE_ENUM.CORPORATE_ACTION,
    others: STREAM_REPORT_TYPE_ENUM.OTHER
};



/***/ }),

/***/ 64999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var global_Securities_stores_useSecuritiesCredentialStore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71158);
/* harmony import */ var global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20620);


var useTradingAccount = function() {
    var tradingType = (0,global_Securities_stores_useSecuritiesCredentialStore__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(s) {
        return s.accountType;
    });
    var isRealTrading = tradingType === global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__/* .ACCOUNT_TYPE.REAL */ .Q5.REAL;
    var isVirtualTrading = tradingType === global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__/* .ACCOUNT_TYPE.VIRTUAL */ .Q5.VIRTUAL;
    return {
        tradingType: tradingType,
        isRealTrading: isRealTrading,
        isVirtualTrading: isVirtualTrading
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useTradingAccount);


/***/ }),

/***/ 1349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78372);
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68425);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37213);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_4__);







var marketDetectorURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_EXODUS_URL */ .q7, "/marketdetectors");
var findataViewURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_EXODUS_URL */ .q7, "/findata-view/marketdetectors");
var seasonalityURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_EXODUS_URL */ .q7, "/seasonality");
var emittenURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_EXODUS_URL */ .q7, "/emitten");
var hotlistURL = "".concat(emittenURL, "/hotlist");
var companyPriceFeedURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_EXODUS_URL */ .q7, "/company-price-feed");
var emittenMetadataURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_EXODUS_URL */ .q7, "/emitten-metadata");
var requestExodus = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"].noAlert */ .Z.noAlert;
// trending
var getTrendingCompany = function() {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_EXODUS_URL */ .q7, "/emitten/trending"));
};
var getIHSG = function() {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_EXODUS_URL */ .q7, "/emitten/IHSG/info"));
};
// Hotlist
var getTopGainer = function() {
    return requestExodus.get("".concat(hotlistURL, "/topgainer?limit=10"));
};
var getTopLoser = function() {
    return requestExodus.get("".concat(hotlistURL, "/toploser?limit=10"));
};
var getMostActive = function() {
    return requestExodus.get("".concat(hotlistURL, "/mostactive?limit=10"));
};
/**
 * Search company with keyword
 */ var getSearchCompany = function(params) {
    return requestExodus.get("/watchlist/search/company", {
        params: params
    });
};
var getCompanyInfo = function(symbol) {
    return requestExodus.get("".concat(emittenURL, "/").concat(symbol, "/info"));
};
/**
 * Get company profile info
 * @param {string} symbol
 * @return {APIResponse}
 */ var getCompanyProfile = function(symbol) {
    return requestExodus.get("".concat(emittenURL, "/").concat(symbol, "/profile"));
};
var getCompanyChart = function(symbol, timeframe) {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_EXODUS_URL */ .q7, "/charts/").concat(symbol, "/daily"), {
        params: {
            timeframe: timeframe
        }
    });
};
var getMarketDetector = function(symbol, params) {
    return requestExodus.get("".concat(marketDetectorURL, "/").concat(symbol), {
        params: params
    });
};
var getTopBroker = function(params) {
    return requestExodus.get("".concat(findataViewURL, "/activity"), {
        params: params
    });
};
var getBrokerList = function(params) {
    return requestExodus.get("".concat(findataViewURL, "/brokers"), {
        params: params
    });
};
var getMarketDetectorActivity = function(brokerCode, params) {
    return requestExodus.get("".concat(findataViewURL, "/activity/").concat(brokerCode, "/detail"), {
        params: params
    });
};
var getAllCorpAction = function(symbol) {
    var limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 30;
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_EXODUS_URL */ .q7, "/corpaction/").concat(symbol), {
        params: {
            limit: limit
        }
    });
};
var getCompanyCorpAction = function(symbol, category) {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_EXODUS_URL */ .q7, "/corpaction/").concat(category), {
        params: {
            symbol: symbol
        }
    });
};
/**
 * Get company major holder, related to get company insider
 * @param {Object} props
 * @param {string=} props.insider
 * @param {string} props.symbol
 * @param {string=} props.datestart
 * @param {string=} props.dateend
 * @param {number=} props.page
 * @returns {APIResponse}
 */ var getCompanyMajorholder = function(param) {
    var _insider = param.insider, insider = _insider === void 0 ? "" : _insider, symbol = param.symbol, _datestart = param.datestart, datestart = _datestart === void 0 ? "" : _datestart, _dateend = param.dateend, dateend = _dateend === void 0 ? "" : _dateend, page = param.page;
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_EXODUS_URL */ .q7, "/insider/company/majorholder"), {
        params: {
            insider: insider,
            symbol: symbol,
            date_start: datestart,
            date_end: dateend,
            page: page
        }
    });
};
/**
 * Get company seasonality data
 * @param {string} symbol
 * @param {string|number} year
 * @param {string|number} backyear
 * @return {APIResponse}
 */ var getCompanySeasonality = function(symbol, year, backyear) {
    return requestExodus.get("".concat(seasonalityURL, "/").concat(symbol), {
        params: {
            year: year,
            back_year: backyear
        }
    });
};
var getCompanyKeystat = function(symbol) {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_EXODUS_URL */ .q7, "/keystats/ratio/v1/").concat(symbol), {
        params: {
            year_limit: 10
        }
    });
};
/**
 * Get financial reports
 * @param {Object} params
 * @param {string} params.symbol
 * @param {string} params.datatype
 * @param {string} params.reporttype
 * @param {string} params.statement
 * @return {APIResponse}
 */ var getFinancialReport = function(param) {
    var symbol = param.symbol, _datatype = param.datatype, datatype = _datatype === void 0 ? 1 : _datatype, reporttype = param.reporttype, statement = param.statement;
    var url = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_EXODUS_URL */ .q7, "/findata-view/company/financial");
    return requestExodus.get(url, {
        params: {
            symbol: symbol,
            data_type: datatype,
            report_type: reporttype,
            statement_type: statement
        }
    }).then(function(res) {
        var newRes = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, res.data);
        newRes.data.defaultCurrency = newRes.data.default_currency;
        newRes.data.htmlReport = newRes.data.html_report;
        newRes.data.rounding_value = {
            idr: newRes.data.rounding_value[0],
            usd: newRes.data.rounding_value[1]
        };
        delete newRes.data.default_currency;
        delete newRes.data.html_report;
        return newRes;
    });
};
/**
 * Get Analyst Rating
 * @param {string} symbol
 * @return {APIResponse}
 */ var getAnalystRating = function(symbol) {
    return requestExodus.get("analyst-ratings/".concat(symbol));
};
var getAnalystConsensus = function(symbol) {
    return requestExodus.get("analyst-ratings/".concat(symbol, "/consensus"));
};
var getCompanyHoldingCompositionToken = function() {
    return requestExodus.post("".concat(emittenMetadataURL, "/shareholders/token"));
};
var getCompanyHoldingComposition = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var symbol, type, timeframe, token, isFromWebview, _tries, tries, getToken, Authorization, res, ref, ref1, statusCode, newToken;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    symbol = param.symbol, type = param.type, timeframe = param.timeframe, token = param.token, isFromWebview = param.isFromWebview, _tries = param.tries, tries = _tries === void 0 ? 0 : _tries;
                    getToken = function() {
                        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                            var ref, tokenResponse, data;
                            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        ;
                                        _ctx.next = 3;
                                        return getCompanyHoldingCompositionToken();
                                    case 3:
                                        tokenResponse = _ctx.sent;
                                        data = tokenResponse.data;
                                        return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.value);
                                    case 6:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }));
                        return function getToken() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    _ctx.t1 = token;
                    if (_ctx.t1) {
                        _ctx.next = 10;
                        break;
                    }
                    _ctx.t2 = !isFromWebview;
                    if (!_ctx.t2) {
                        _ctx.next = 9;
                        break;
                    }
                    _ctx.next = 8;
                    return getToken();
                case 8:
                    _ctx.t2 = _ctx.sent;
                case 9:
                    _ctx.t1 = _ctx.t2;
                case 10:
                    _ctx.t0 = _ctx.t1;
                    if (_ctx.t0) {
                        _ctx.next = 13;
                        break;
                    }
                    _ctx.t0 = "";
                case 13:
                    Authorization = _ctx.t0;
                    _ctx.prev = 14;
                    if (Authorization) {
                        _ctx.next = 17;
                        break;
                    }
                    throw Error("No Access Token found");
                case 17:
                    _ctx.next = 19;
                    return axios__WEBPACK_IMPORTED_MODULE_4___default().get("".concat(emittenMetadataURL, "/shareholders/").concat(symbol, "/chart"), {
                        params: {
                            symbol: symbol,
                            value_year: timeframe,
                            shareholder_type: type
                        },
                        headers: {
                            Authorization: Authorization
                        }
                    });
                case 19:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 23:
                    _ctx.prev = 23;
                    _ctx.t3 = _ctx["catch"](14);
                    ;
                    ;
                    statusCode = (ref1 = _ctx.t3 === null || _ctx.t3 === void 0 ? void 0 : (ref = _ctx.t3.response) === null || ref === void 0 ? void 0 : ref.status) !== null && ref1 !== void 0 ? ref1 : 401;
                    if (!(isFromWebview || statusCode !== 401 || tries >= 2)) {
                        _ctx.next = 30;
                        break;
                    }
                    throw _ctx.t3;
                case 30:
                    _ctx.next = 32;
                    return getToken();
                case 32:
                    newToken = _ctx.sent;
                    return _ctx.abrupt("return", getCompanyHoldingComposition({
                        symbol: symbol,
                        type: type,
                        timeframe: timeframe,
                        isFromWebview: isFromWebview,
                        token: newToken,
                        tries: tries + 1
                    }));
                case 34:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                14,
                23
            ]
        ]);
    }));
    return function getCompanyHoldingComposition(_) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Get company contact
 * @param {string} symbol
 * @return {APIResponse}
 */ var getCompanyContact = function(symbol) {
    return requestExodus.get("".concat(emittenURL, "/").concat(symbol, "/contact"));
};
var getTradeBook = function(params) {
    return requestExodus.get("".concat(companyPriceFeedURL, "/trade-book"), {
        params: params
    });
};
var getInitRunningTrade = function(params) {
    return requestExodus.get("".concat(companyPriceFeedURL, "/running-trade"), {
        params: params
    });
};
var getInitRunningTradeV2 = function(params) {
    return requestExodus.get("".concat(companyPriceFeedURL, "/v2/running-trade"), {
        params: params
    });
};
var getCompanySubsidiary = function(symbol) {
    return requestExodus.get("".concat(emittenMetadataURL, "/subsidiary/").concat(symbol));
};
var getCompanyInfoV2 = function(symbol, exchange) {
    return requestExodus.get("".concat(emittenURL, "/v2/").concat(exchange, "/").concat(symbol, "/info"));
};
var getCompanyChartV2 = function(symbol, timeframe) {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_EXODUS_URL */ .q7, "/charts/").concat(symbol), {
        params: {
            timeframe: timeframe
        }
    });
};
var getCompanyFinItem = function(symbol, exchange) {
    return requestExodus.get("".concat(emittenURL, "/v2/").concat(exchange, "/").concat(symbol, "/fin-items"));
};
var getGuestCompanyV2 = function(symbol, exchange) {
    var reqDetail = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(false);
    return reqDetail.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_EXODUS_URL */ .q7, "/emitten/non-login/v2/").concat(exchange, "/").concat(symbol, "/info"));
};
var getGuestCompanyChartV2 = function(symbol, timeframe) {
    var reqDetail = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(false);
    return reqDetail.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_EXODUS_URL */ .q7, "/partnership/charts/").concat(symbol), {
        params: {
            timeframe: timeframe
        }
    });
};
var getGuestCompanyFinItem = function(symbol, exchange) {
    return axios__WEBPACK_IMPORTED_MODULE_4___default().get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_3__/* .API_EXODUS_URL */ .q7, "/emitten/non-login/v2/").concat(exchange, "/").concat(symbol, "/fin-items"));
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getTrendingCompany: getTrendingCompany,
    getIHSG: getIHSG,
    getSearchCompany: getSearchCompany,
    getCompanyProfile: getCompanyProfile,
    getCompanyInfo: getCompanyInfo,
    getCompanyChart: getCompanyChart,
    getAnalystRating: getAnalystRating,
    getAnalystConsensus: getAnalystConsensus,
    getCompanyContact: getCompanyContact,
    getCompanyInfoV2: getCompanyInfoV2,
    getCompanyChartV2: getCompanyChartV2,
    getCompanyFinItem: getCompanyFinItem,
    // Hotlist
    getTopGainer: getTopGainer,
    getTopLoser: getTopLoser,
    getMostActive: getMostActive,
    // bandar detector
    getMarketDetector: getMarketDetector,
    getBrokerList: getBrokerList,
    getMarketDetectorActivity: getMarketDetectorActivity,
    getTopBroker: getTopBroker,
    // related to profile APIs
    getCompanyCorpAction: getCompanyCorpAction,
    getCompanyMajorholder: getCompanyMajorholder,
    getCompanySeasonality: getCompanySeasonality,
    getCompanyKeystat: getCompanyKeystat,
    getFinancialReport: getFinancialReport,
    getAllCorpAction: getAllCorpAction,
    // used for trading modal
    getCompanyHoldingCompositionToken: getCompanyHoldingCompositionToken,
    getCompanyHoldingComposition: getCompanyHoldingComposition,
    // Company Price Feed,
    getTradeBook: getTradeBook,
    getInitRunningTrade: getInitRunningTrade,
    getCompanySubsidiary: getCompanySubsidiary,
    getInitRunningTradeV2: getInitRunningTradeV2,
    getGuestCompanyV2: getGuestCompanyV2,
    getGuestCompanyChartV2: getGuestCompanyChartV2,
    getGuestCompanyFinItem: getGuestCompanyFinItem
});


/***/ }),

/***/ 63699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37213);
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68425);
/* harmony import */ var features_discover_people_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28635);
/* eslint-disable import/named */ 


var requestExodus = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
var suggestionURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_0__/* .API_EXODUS_URL */ .q7, "/friend-discovery/suggestions");
var FRIEND_DISCOVERY = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_0__/* .API_EXODUS_URL */ .q7, "/friend-discovery");
var getSuggestFriends = function(config) {
    var limit = config.limit, page = config.page, _filter = config.filter, filter = _filter === void 0 ? 0 : _filter;
    return requestExodus.get("".concat(suggestionURL, "/query"), {
        params: {
            limit: limit,
            page: page,
            filter: filter
        }
    });
};
var getSuggestFriendsContacts = function(limit, page) {
    return requestExodus.get("".concat(suggestionURL, "/contacts"), {
        params: {
            limit: limit,
            page: page
        }
    });
};
var getBlacklistStatus = function() {
    return requestExodus.get("".concat(FRIEND_DISCOVERY, "/contacts/discoverable"));
};
var updateBlacklistStatus = function() {
    return requestExodus.post("".concat(FRIEND_DISCOVERY, "/contacts/discoverable"));
};
var getContactSyncStatus = function() {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_0__/* .API_EXODUS_URL */ .q7, "/friend-discovery/contacts/status"));
};
var getFollowedBy = function(params) {
    return requestExodus.get("".concat(FRIEND_DISCOVERY, "/followed-by"), {
        params: params
    });
};
var getTrending = function() {
    var timeframe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : features_discover_people_types__WEBPACK_IMPORTED_MODULE_2__/* .TrendingTimeFrame.ALL */ .b.ALL, limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100, cursor = arguments.length > 2 ? arguments[2] : void 0;
    return requestExodus.get("user/v2/discovery/trending", {
        params: {
            time_frame: timeframe,
            limit: limit,
            cursor: cursor
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getSuggestFriends: getSuggestFriends,
    getSuggestFriendsContacts: getSuggestFriendsContacts,
    getBlacklistStatus: getBlacklistStatus,
    updateBlacklistStatus: updateBlacklistStatus,
    getContactSyncStatus: getContactSyncStatus,
    getFollowedBy: getFollowedBy,
    getTrending: getTrending
});


/***/ }),

/***/ 51679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78372);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37213);
/* harmony import */ var global_StreamWidget_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21390);
/* harmony import */ var utils_stream__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14601);
/** @typedef {import('../../../@types/api-response').APIResponse} APIResponse */ /* eslint-disable camelcase */ 





var requestExodus = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"].defaultInstance */ .Z.defaultInstance;
var requestExodusNoAlert = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"].noAlert */ .Z.noAlert;
// TODO: Change exodus url to stream url later on after every `/stream` path is migrated and tested
var STREAM_EXODUS_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/stream");
var STREAM_EXODUS_V3_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/stream/v3");
var STREAM_UPLOAD_TOKEN = "".concat(STREAM_EXODUS_URL, "/uploadtoken");
var STREAM_UPLOAD_TOKEN_V2 = "".concat(STREAM_EXODUS_URL, "/upload-tokens");
// Stockbit Stream -------------------------------------------------------------
/**
 * like stream post
 * @param {string} postid - post id
 * @returns {APIResponse}
 */ var likeStreamPost = function(postid) {
    return requestExodusNoAlert.post("".concat(STREAM_EXODUS_URL, "/like/").concat(postid));
};
/**
 * unlike stream post
 * @param {string} postid - post id
 * @returns {APIResponse}
 */ var unlikeStreamPost = function(postid) {
    return requestExodusNoAlert.post("".concat(STREAM_EXODUS_URL, "/unlike/").concat(postid));
};
/**
 *
 * @param {number=} version
 *
 * @param {Object} param
 * @param {number=} param.clean
 * @param {number=} param.beforelastpost
 * @param {string=} param.category
 * @param {number=} param.lastpost
 * @param {*=} param.keyword
 * @param {number=} param.limit
 * @param {string=} param.from
 * @param {string=} param.to
 * @param {string=} param.beforetimestamp
 * @returns {APIResponse}
 */ var getStream = function() {
    var version = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : global_StreamWidget_constants__WEBPACK_IMPORTED_MODULE_3__/* .STREAM_VERSION.V3 */ .hD.V3, ref = arguments.length > 1 ? arguments[1] : void 0, _clean = ref.clean, clean = _clean === void 0 ? 0 : _clean, _beforelastpost = ref.beforelastpost, beforelastpost = _beforelastpost === void 0 ? 0 : _beforelastpost, _category = ref.category, category = _category === void 0 ? "all" : _category, _lastpost = ref.lastpost, lastpost = _lastpost === void 0 ? 0 : _lastpost, keyword = ref.keyword, _limit = ref.limit, limit = _limit === void 0 ? 20 : _limit, _type = ref.type, type = _type === void 0 ? "latest" : _type, _from = ref.from, from = _from === void 0 ? "" : _from, _to = ref.to, to = _to === void 0 ? "" : _to, _beforetimestamp = ref.beforetimestamp, beforetimestamp = _beforetimestamp === void 0 ? null : _beforetimestamp, _date = ref.date, date = _date === void 0 ? moment__WEBPACK_IMPORTED_MODULE_0___default()(new Date()).format("YYYY-MM-DD") : _date, _page = ref.page, page = _page === void 0 ? 1 : _page, _reporttype = ref.reporttype, reporttype = _reporttype === void 0 ? "" : _reporttype;
    var params = {
        clean: clean,
        beforelastpost: beforelastpost,
        category: category,
        lastpost: lastpost,
        keyword: keyword,
        limit: limit,
        from: from,
        to: to,
        beforetimestamp: beforetimestamp
    };
    var streamURL = STREAM_EXODUS_V3_URL;
    if (type === "latest") {
        params.category = category;
        if (category === "reports") {
            params.reporttype = reporttype;
        }
    } else if (type === "trending" && !keyword) {
        streamURL = "".concat(streamURL, "/trending");
        params = {
            date: date,
            page: page,
            limit: limit
        };
    } else {
        // For non Ideas Filter will have type 'ideas', use category as category
        // For Ideas with non 'All' filter, use type as category
        if (type === "ideas") {
            params.category = category;
        } else if (type === "trending" && keyword) {
            params.category = category;
        } else {
            params.category = type;
        }
        // Only report category has reporttype
        if (category === "reports") {
            params.reporttype = reporttype;
        } else {
            params.filter = "all";
        }
    }
    // Cleanup params with empty value
    params = (0,utils_stream__WEBPACK_IMPORTED_MODULE_4__/* .cleanupStreamPayload */ .Hm)(params);
    var body = {};
    if (type !== "trending" || keyword) {
        body = {
            category: global_StreamWidget_constants__WEBPACK_IMPORTED_MODULE_3__/* .TAB_CATEGORIES */ .oK[params.category],
            last_stream_id: lastpost,
            last_reply: beforetimestamp,
            keyword: keyword,
            from_date: from,
            to_date: to,
            limit: limit
        };
        if (params.reporttype) {
            // eslint-disable-next-line dot-notation
            body["report_type"] = global_StreamWidget_constants__WEBPACK_IMPORTED_MODULE_3__/* .STREAM_REPORT */ .OW[params.reporttype];
        }
    } else if (type === "trending" && !keyword) {
        body = {
            date: date,
            last_stream_id: lastpost,
            limit: limit
        };
    }
    body = (0,utils_stream__WEBPACK_IMPORTED_MODULE_4__/* .cleanupStreamPayload */ .Hm)(body);
    return requestExodus.post(streamURL, body);
};
/**
 * Get user stream data
 * @param {string} username
 *
 * @param {Object} param
 * @param {number} param.beforelastpost
 * @param {string} param.category
 * @param {number} param.lastpost
 * @param {*} param.keyword
 * @param {number} param.limit
 * @param {string} param.from
 * @param {string} param.to
 * @returns {APIResponse}
 */ var getUserStream = function(username, param) {
    var _category = param.category, category = _category === void 0 ? "all" : _category, _lastpost = param.lastpost, lastpost = _lastpost === void 0 ? 0 : _lastpost, keyword = param.keyword, _limit = param.limit, limit = _limit === void 0 ? 20 : _limit, _from = param.from, from = _from === void 0 ? "" : _from, _to = param.to, to = _to === void 0 ? "" : _to;
    var streamURL = "".concat(STREAM_EXODUS_V3_URL, "/user");
    var body = {
        category: global_StreamWidget_constants__WEBPACK_IMPORTED_MODULE_3__/* .TAB_USER_CATEGORIES */ .DY[category],
        last_stream_id: lastpost,
        keyword: keyword,
        from_date: from,
        to_date: to,
        limit: limit
    };
    body = (0,utils_stream__WEBPACK_IMPORTED_MODULE_4__/* .cleanupStreamPayload */ .Hm)(body);
    return requestExodus.post("".concat(streamURL, "/").concat(username), body);
};
/**
 * Get company stream data
 * @param {string} symbol
 *
 * @param {Object} param
 * @param {number} param.beforelastpost
 * @param {string} param.category
 * @param {number} param.lastpost
 * @param {*} param.keyword
 * @param {number} param.limit
 * @param {string} param.from
 * @param {string} param.to
 * @returns {APIResponse}
 */ var getSymbolStream = function(symbol, param) {
    var _category = param.category, category = _category === void 0 ? "all" : _category, _lastpost = param.lastpost, lastpost = _lastpost === void 0 ? 0 : _lastpost, keyword = param.keyword, _limit = param.limit, limit = _limit === void 0 ? 20 : _limit, _from = param.from, from = _from === void 0 ? "" : _from, _to = param.to, to = _to === void 0 ? "" : _to, _reporttype = param.reporttype, reporttype = _reporttype === void 0 ? "" : _reporttype;
    var streamURL = "".concat(STREAM_EXODUS_V3_URL, "/symbol");
    var body = {};
    body = {
        category: global_StreamWidget_constants__WEBPACK_IMPORTED_MODULE_3__/* .TAB_CATEGORIES */ .oK[category],
        last_stream_id: lastpost,
        keyword: keyword,
        from_date: from,
        to_date: to,
        limit: limit
    };
    if (reporttype) {
        // eslint-disable-next-line dot-notation
        body["report_type"] = global_StreamWidget_constants__WEBPACK_IMPORTED_MODULE_3__/* .STREAM_REPORT */ .OW[reporttype];
    }
    body = (0,utils_stream__WEBPACK_IMPORTED_MODULE_4__/* .cleanupStreamPayload */ .Hm)(body);
    return requestExodusNoAlert.post("".concat(streamURL, "/").concat(symbol), body);
};
/**
 * Get stream post detail by post id
 * @param {string} symbol
 * @returns {APIResponse}
 */ var getGuestStream = function(symbol) {
    return requestExodusNoAlert.get("".concat(STREAM_EXODUS_URL, "/non-login/symbol/").concat(symbol));
};
/**
 * Get company data for guest
 * @param {string} symbol
 * @returns {APIResponse}
 */ var getGuestCompany = function(symbol) {
    return requestExodusNoAlert.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/emitten/non-login/").concat(symbol, "/info"));
};
/**
 * Get company profile info
 * @param {string} symbol
 * @returns {APIResponse}
 */ var getGuestCompanyProfile = function(symbol) {
    return requestExodusNoAlert.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/partnership/emitten/").concat(symbol, "/profile"));
};
/**
 * Get chart data for guest
 * @param {string} symbol
 * @returns {APIResponse}
 */ var getGuestChart = function(symbol) {
    var timeframe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "today";
    return requestExodusNoAlert.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/partnership/charts/").concat(symbol, "/daily?timeframe=").concat(timeframe));
};
/**
 * Get stream post detail by post id
 * @param {string|number} postId
 * @returns {APIResponse}
 */ var getStreamDetail = function(postId) {
    var streamURL = "".concat(STREAM_EXODUS_V3_URL, "/post/").concat(postId);
    return requestExodusNoAlert.post(streamURL);
};
/**
 * Get stream post detail by post id
 * @param {string|number} postId
 * @returns {APIResponse}
 */ var getGuestStreamDetail = function(postId) {
    return requestExodusNoAlert.get("".concat(STREAM_EXODUS_URL, "/non-login/post/").concat(postId));
};
/**
 * getUploadToken
 * @param {string} bucket - bucket'sname
 * @returns {APIResponse}
 */ var getUploadToken = function() {
    var bucket = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "avatar";
    return requestExodusNoAlert.get("".concat(STREAM_UPLOAD_TOKEN), {
        params: {
            bucket: bucket
        }
    });
};
/**
 * postUploadAWS
 * @param {object} formData - file formdata
 * @returns {APIResponse}
 */ var postUploadAWS = function(formData) {
    return fetch(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .AWS_AVATAR_BUCKET */ .cU, {
        method: "POST",
        cache: "default",
        body: formData,
        mode: "cors"
    }).then(function(response) {
        if (response.status === 200) {
            return response.json();
        }
        // TODO: alert error message
        return false;
    });
};
/**
 * API Compose new Stream
 * @param {Object} param
 * @param {string} param.content
 * @param {string} param.image
 * @param {Array} param.images
 * @param {Object} param.file
 * @param {number} param.target_price
 * @param {string} param.target_symbol
 * @param {number} param.target_duration
 * @param {Object=} param.polling
 * @param {string} param.commenter_type
 * @returns {APIResponse}
 */ var postStream = function(param) {
    var content = param.content, image = param.image, _images = param.images, images = _images === void 0 ? [] : _images, _file = param.file, file = _file === void 0 ? "" : _file, target_price = param.target_price, target_symbol = param.target_symbol, target_duration = param.target_duration, polling = param.polling, commenter_type = param.commenter_type;
    var data = {
        content: content,
        image: image,
        images: images,
        file: file,
        target_price: target_price,
        target_symbol: target_symbol,
        target_duration: target_duration,
        sharefacebook: 0,
        sharetwitter: 0,
        commenter_type: commenter_type
    };
    if (polling) {
        data.polling_end = polling.polling_end;
        data.polling_options = polling.polling_options;
        data.polling_pin = polling.polling_pin;
    }
    return requestExodus.post("".concat(STREAM_EXODUS_URL, "/write"), data);
};
/**
 * API Update Post Stream
 * @param {Object} param
 * @param {string} param.content
 * @param {string} param.image
 * @param {Array} param.images
 * @param {Object} param.file
 * @param {number} param.target_price
 * @param {string} param.target_symbol
 * @param {number} param.target_duration
 * @param {Object=} param.polling
 * @param {number} param.postid
 * @param {string} param.commenter_type
 * @returns {APIResponse}
 */ var updatePostStream = function(param) {
    var content = param.content, image = param.image, _images = param.images, images = _images === void 0 ? [] : _images, _file = param.file, file = _file === void 0 ? "" : _file, target_price = param.target_price, target_symbol = param.target_symbol, target_duration = param.target_duration, polling = param.polling, postid = param.postid, commenter_type = param.commenter_type;
    var data = {
        content: content,
        image: image,
        images: images,
        file: file,
        target_price: target_price,
        target_symbol: target_symbol,
        target_duration: target_duration,
        sharefacebook: 0,
        sharetwitter: 0,
        commenter_type: commenter_type
    };
    if (polling) {
        data.polling_end = polling.polling_end;
        data.polling_options = polling.polling_options;
        data.polling_pin = polling.polling_pin;
    }
    return requestExodus.post("".concat(STREAM_EXODUS_URL, "/update/").concat(postid), data);
};
/**
 * API Share Post Stream
 * @param {Object} param
 * @param {string} param.content
 * @param {string} param.images
 * @param {Object} param.file
 * @param {number} param.postid
 * @param {number=} param.facebook
 * @param {number=} param.twitter
 * @param {number=} param.stockbit
 * @param {number=} param.commenter_type
 * @returns {APIResponse}
 */ var sharePostStream = function(param) {
    var content = param.content, images = param.images, file = param.file, postid = param.postid, _facebook = param.facebook, facebook = _facebook === void 0 ? 0 : _facebook, _twitter = param.twitter, twitter = _twitter === void 0 ? 0 : _twitter, _stockbit = param.stockbit, stockbit = _stockbit === void 0 ? 0 : _stockbit, commenter_type = param.commenter_type;
    var data = {
        postid: postid,
        content: content,
        images: images,
        file: file,
        facebook: facebook,
        twitter: twitter,
        stockbit: stockbit,
        commenter_type: commenter_type
    };
    return requestExodus.post("".concat(STREAM_EXODUS_URL, "/share/").concat(postid), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, data));
};
/**
 * Function to post vote to target price post
 * @param {number} targetPriceId - target price id
 * @param {0 | 1} agree - agree status 1: agree, 0: disagree
 * @returns {APIResponse}
 */ var postVoteTargetPrice = function(targetPriceId, agree) {
    var bodyFormData = new URLSearchParams();
    bodyFormData.append("tp_id", targetPriceId);
    bodyFormData.append("agree", agree);
    return requestExodusNoAlert.post("".concat(STREAM_EXODUS_URL, "/addvote/").concat(targetPriceId), bodyFormData);
};
/**
 * Follow Post
 * @param {number|string} postid
 * @returns {APIResponse}
 */ var followPost = function(postid) {
    return requestExodusNoAlert.post("".concat(STREAM_EXODUS_URL, "/follow/").concat(postid));
};
/**
 * UnFollow Post
 * @param {number|string} postid
 * @returns {APIResponse}
 */ var unfollowPost = function(postid) {
    return requestExodusNoAlert.post("".concat(STREAM_EXODUS_URL, "/unfollow/").concat(postid));
};
/**
 * Save Post
 * @param {number|string} postid
 * @returns {APIResponse}
 */ var savePost = function(postid) {
    return requestExodus.post("".concat(STREAM_EXODUS_URL, "/save/").concat(postid));
};
/**
 * UnSave Post
 * @param {number|string} postid
 * @returns {APIResponse}
 */ var unsavePost = function(postid) {
    return requestExodusNoAlert.post("".concat(STREAM_EXODUS_URL, "/unsave/").concat(postid));
};
/**
 *  Get Announcement Report
 * @param {number|string} postid
 * @returns {APIResponse}
 */ var getAnnouncementReports = function(postid) {
    return requestExodusNoAlert.get("".concat(STREAM_EXODUS_URL, "/announcement/").concat(postid));
};
/**
 * Post Report Stream
 * @param {number|string} postid
 * @param {string} type
 * @param {string} message
 * @returns {APIResponse}
 */ var postReportStream = function(postid, type, message) {
    var form = new URLSearchParams();
    form.append("type", type);
    form.append("message", message);
    return requestExodus.post("".concat(STREAM_EXODUS_URL, "/report/").concat(postid), form);
};
/**
 * Delete Post Stream
 * @param {number|string} postid
 * @param {string} reason
 * @param {boolean} sendEmail
 * @returns {APIResponse}
 */ var deletePostStream = function(postid, reason) {
    var sendEmail = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var data = {
        reason: reason,
        send_email: sendEmail
    };
    return requestExodus.post("".concat(STREAM_EXODUS_URL, "/v2/delete/").concat(postid), data);
};
/**
 * Delete Own Post Stream
 * @param {number|string} postid
 * @returns {APIResponse}
 */ var deleteOwnPostStream = function(postid) {
    return requestExodus.delete("".concat(STREAM_EXODUS_URL, "/own/").concat(postid));
};
/**
 * Delete Own Post Stream
 * @param {number|string} postid
 * @returns {APIResponse}
 */ var deleteOwnPostComment = function(postid) {
    return requestExodus.delete("".concat(STREAM_EXODUS_URL, "/own/comment/").concat(postid));
};
/**
 * Delete Multiple Post Stream
 * @param {number|string} userid
 * @param {string} time
 * @param {string} reason
 * @param {bool} sendEmail
 * @returns {APIResponse}
 */ var deleteMultiplePostStream = function(userid, time, reason) {
    var sendEmail = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var data = {
        user_id: userid,
        period: time,
        send_email: sendEmail,
        reason: reason
    };
    return requestExodus.post("".concat(STREAM_EXODUS_URL, "/delete/multiple"), data);
};
/**
 * Pin Post
 * @param {number|string} postid
 * @param {string} symbol
 * @returns {APIResponse}
 */ var pinPost = function(postid, symbol) {
    var data = new URLSearchParams();
    data.append("postid", postid);
    if (symbol) data.append("symbol", symbol);
    return requestExodus.post("".concat(STREAM_EXODUS_URL, "/pin?").concat(data.toString()));
};
/**
 * UnPin Post
 * @param {number|string} postid
 * @param {string} symbol
 * @returns {APIResponse}
 */ var unpinPost = function(postid, symbol) {
    var data = new URLSearchParams();
    data.append("postid", postid);
    if (symbol) data.append("symbol", symbol);
    return requestExodus.post("".concat(STREAM_EXODUS_URL, "/unpin?").concat(data.toString()));
};
/**
 * Get user pinned post
 * @param {string} username
 * @returns {APIResponse}
 */ var getPinnedPost = function(username) {
    return requestExodusNoAlert.post("".concat(STREAM_EXODUS_V3_URL, "/user/").concat(username, "/pinned"));
};
/**
 * Get company pinned post
 * @param {string} symbol
 * @returns {APIResponse}
 */ var getCompanyPinnedPost = function(symbol) {
    return requestExodusNoAlert.get("/stream/v3/symbol/".concat(symbol, "/pinned"));
};
/**
 * Get Stream Conversation
 * @param {number|string} postid
 * @returns {APIResponse}
 */ var getStreamConversation = function(param) {
    var postId = param.postId, parentId = param.parentId;
    var streamURL = "".concat(STREAM_EXODUS_V3_URL, "/conversation");
    var body = {
        stream_id: postId,
        limit: 20
    };
    var parentID = parentId > 0 ? parentId : postId;
    body = (0,utils_stream__WEBPACK_IMPORTED_MODULE_4__/* .cleanupStreamPayload */ .Hm)(body);
    return requestExodusNoAlert.post("".concat(streamURL, "/").concat(parentID), body);
};
/**
 * Get Prev Stream Conversation
 * @param {number|string} postid
 * @returns {APIResponse}
 */ var getPrevStreamConversation = function(postid) {
    var streamURL = "".concat(STREAM_EXODUS_V3_URL, "/conversation");
    var body = {
        stream_id: postid,
        is_previous: true,
        limit: 20
    };
    body = (0,utils_stream__WEBPACK_IMPORTED_MODULE_4__/* .cleanupStreamPayload */ .Hm)(body);
    return requestExodusNoAlert.post("".concat(streamURL, "/comments"), body);
};
/**
 * Post Reply Stream
 * @param {Object} param
 * @param {string=} param.content
 * @param {string=} param.image
 * @param {string=} param.images
 * @param {Object=} param.file
 * @param {number=} param.postid
 * @param {number} param.replyto
 * @param {number|string} param.parent
 * @returns {APIResponse}
 */ var postReplyStream = function(param) {
    var _content = param.content, content = _content === void 0 ? "" : _content, _image = param.image, image = _image === void 0 ? null : _image, _images = param.images, images = _images === void 0 ? [] : _images, _file = param.file, file = _file === void 0 ? null : _file, replyto = param.replyto, parent = param.parent;
    var data = {
        content: content,
        image: image,
        images: images,
        file: file,
        sharefacebook: 0,
        sharetwitter: 0
    };
    if (replyto) {
        data.replyto = replyto;
    }
    return requestExodus.post("".concat(STREAM_EXODUS_URL, "/reply/").concat(parent), data);
};
/**
 * Untag all post topics inside stream post
 * @param {number} postId - Stream post ID
 * @returns {APIResponse}
 */ var untagPostTopic = function(postId) {
    return requestExodus.post("".concat(STREAM_EXODUS_URL, "/topic/untag/").concat(postId));
};
/**
 * Get stream likers
 * @param {string} username
 * @param {string | number} postid
 * @param {number} page
 * @return {APIResponse}
 */ var getStreamLikers = function(username, postid) {
    var page = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    return requestExodusNoAlert.get("".concat(STREAM_EXODUS_URL, "/likers/").concat(postid), {
        params: {
            username: username,
            page: page
        }
    });
};
/**
 * getUploadToken version 2
 * @param {string} filename
 * @returns {APIResponse}
 */ var getUploadTokenV2 = function(params) {
    return requestExodusNoAlert.get("".concat(STREAM_UPLOAD_TOKEN_V2), {
        params: params
    });
};
/**
 * Change Commenter Type of Post
 * @param {number} type - Stream post Commenter Type
 * @param {string | number} postid
 * @returns {APIResponse}
 */ var changeCommenterType = function(type, postid) {
    return requestExodus.put("".concat(STREAM_EXODUS_URL, "/commenter-type/").concat(postid), {
        commenter_type: type
    });
};
/**
 * Post Polling Vote
 * @param {number} pollingId - Stream post ID
 * @param {number} option - selected option
 * @returns {APIResponse}
 */ var postPollingVote = function(pollingId, option) {
    return requestExodus.post("".concat(STREAM_EXODUS_URL, "/polling/vote/").concat(pollingId), {
        option: option
    });
};
var getGuestUserStream = function(username) {
    return requestExodusNoAlert.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/stream/non-login/user/").concat(username));
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    likeStreamPost: likeStreamPost,
    unlikeStreamPost: unlikeStreamPost,
    getStream: getStream,
    getUserStream: getUserStream,
    getSymbolStream: getSymbolStream,
    getStreamDetail: getStreamDetail,
    getUploadToken: getUploadToken,
    postUploadAWS: postUploadAWS,
    postStream: postStream,
    updatePostStream: updatePostStream,
    sharePostStream: sharePostStream,
    postVoteTargetPrice: postVoteTargetPrice,
    followPost: followPost,
    unfollowPost: unfollowPost,
    savePost: savePost,
    unsavePost: unsavePost,
    getAnnouncementReports: getAnnouncementReports,
    postReportStream: postReportStream,
    deletePostStream: deletePostStream,
    deleteOwnPostStream: deleteOwnPostStream,
    deleteOwnPostComment: deleteOwnPostComment,
    deleteMultiplePostStream: deleteMultiplePostStream,
    pinPost: pinPost,
    unpinPost: unpinPost,
    getPinnedPost: getPinnedPost,
    getCompanyPinnedPost: getCompanyPinnedPost,
    getStreamLikers: getStreamLikers,
    getStreamConversation: getStreamConversation,
    getPrevStreamConversation: getPrevStreamConversation,
    postReplyStream: postReplyStream,
    untagPostTopic: untagPostTopic,
    getUploadTokenV2: getUploadTokenV2,
    getGuestStreamDetail: getGuestStreamDetail,
    getGuestStream: getGuestStream,
    getGuestCompany: getGuestCompany,
    getGuestCompanyProfile: getGuestCompanyProfile,
    changeCommenterType: changeCommenterType,
    getGuestChart: getGuestChart,
    postPollingVote: postPollingVote,
    getGuestUserStream: getGuestUserStream
});


/***/ }),

/***/ 79644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ VerifiedStatus; }
/* harmony export */ });
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68425);
/** @typedef {import('axios').AxiosResponse} AxiosResponse */ 
var requestExodus = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
// Configs
var VERIFIED_BADGE_URL = "/verified-badge";
var VERIFIED_BADGE_USER_URL = "".concat(VERIFIED_BADGE_URL, "/user");
/**
 * Get verified badge user
 * @param {Number} userId - userid
 * @return {AxiosResponse}
 */ var getVerifiedBadgeUser = function(userId) {
    return requestExodus.get("".concat(VERIFIED_BADGE_USER_URL, "/").concat(userId));
};
var VerifiedStatus;
(function(VerifiedStatus) {
    VerifiedStatus["VERIFIED_STATUS_UNVERIFIED"] = "VERIFIED_STATUS_UNVERIFIED";
    VerifiedStatus["VERIFIED_STATUS_IDENTITY"] = "VERIFIED_STATUS_IDENTITY";
    VerifiedStatus["VERIFIED_STATUS_COMMUNITY"] = "VERIFIED_STATUS_COMMUNITY";
})(VerifiedStatus || (VerifiedStatus = {}));
// Exports ---------------------------------------------------------------------

/* harmony default export */ __webpack_exports__["Z"] = ({
    getVerifiedBadgeUser: getVerifiedBadgeUser
});


/***/ }),

/***/ 74645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_P": function() { return /* binding */ STATE_DETAIL; },
  "yM": function() { return /* binding */ STATE_SEARCH; },
  "IN": function() { return /* binding */ STATE_SUGGESTION; },
  "ZP": function() { return /* binding */ entities_company; },
  "Sz": function() { return /* binding */ effects; },
  "wl": function() { return /* binding */ selectors; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(61876);
// EXTERNAL MODULE: ./src/lib/api/watchlist.ts
var watchlist = __webpack_require__(15056);
// EXTERNAL MODULE: ./src/lib/api/company.ts
var company = __webpack_require__(1349);
// EXTERNAL MODULE: ./src/lib/api/search.ts
var search = __webpack_require__(44590);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
;// CONCATENATED MODULE: ./src/lib/models/company/follow.js

var schema = {
    change: 0,
    companyid: "",
    followed: 0,
    followers: "",
    percent: 0,
    price: "",
    symbol: ""
};
var propTypes = {
    change: prop_types.number,
    companyid: prop_types.string,
    followed: prop_types.number,
    followers: prop_types.string,
    percent: prop_types.number,
    price: prop_types.string,
    symbol: prop_types.string
};
/* harmony default export */ var follow = ({
    schema: schema,
    propTypes: propTypes
});

;// CONCATENATED MODULE: ./src/lib/entities/company.ts









// States can be updated through follow/unfollow
var STATE_SUGGESTION = "suggestion";
var STATE_SEARCH = "search";
var STATE_DETAIL = "detail";
var defaultSummary = {
    brokers_buy: [],
    brokers_sell: [],
    symbol: ""
};
// Initial state
var initialState = {
    detail: {
        data: {},
        isLoading: false,
        error: null,
        message: ""
    },
    search: {
        data: [],
        isLoading: false,
        error: null,
        message: ""
    },
    chart: {
        data: {},
        isLoading: false,
        error: null,
        message: ""
    },
    postFollowCompany: {
        data: [],
        isLoading: false,
        error: null,
        message: ""
    },
    postUnfollowCompany: {
        data: follow.schema,
        isLoading: false,
        error: null,
        message: ""
    },
    contact: {
        data: {},
        isLoading: false,
        error: null,
        message: ""
    },
    brokerSummary: {
        data: {
            detector: {},
            summary: defaultSummary,
            from: "",
            to: ""
        },
        isLoading: false,
        error: null,
        message: ""
    }
};
// Selectors
// export const selectors = createSelector(
//   (state) => ({
//     search: state.entities.company.search,
//     detail: state.entities.company.detail,
//     chart: state.entities.company.chart,
//   }),
//   (state) => state,
// );
var companySelector = function(state) {
    return state.entities.company;
};
var selectors = (0,es/* createSelector */.P1)(companySelector, function(company) {
    return (0,_object_spread/* default */.Z)({}, company);
});
// Action types
var CONTEXT = "@redux/company";
var actionType = {
    FETCH_SEARCH: "".concat(CONTEXT, "/FETCH_SEARCH"),
    CLEAR_SEARCH: "".concat(CONTEXT, "/CLEAR_SEARCH"),
    POST_FOLLOW_COMPANY: "".concat(CONTEXT, "/POST_FOLLOW_COMPANY"),
    POST_UNFOLLOW_COMPANY: "".concat(CONTEXT, "/POST_UNFOLLOW_COMPANY"),
    GET_COMPANY_DETAIL: "".concat(CONTEXT, "/GET_COMPANY_DETAIL"),
    GET_COMPANY_CHART: "".concat(CONTEXT, "/GET_COMPANY_CHART"),
    GET_COMPANY_CONTACT: "".concat(CONTEXT, "/GET_COMPANY_CONTACT"),
    FOLLOW_USER: "".concat(CONTEXT, "/FOLLOW_USER"),
    GET_BANDAR_DETECTOR: "".concat(CONTEXT, "/GET_BANDAR_DETECTOR")
};
// symbol, timeframe
// Effects
// Side effect from external
var effects = {
    getSearchCompany: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.FETCH_SEARCH, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(keyword) {
            var response, _data, data, message, _$error, sanitizedData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return search/* default.getSearchCompany */.Z.getSearchCompany(keyword);
                    case 3:
                        response = _ctx.sent;
                        if (!response.data) {
                            _ctx.next = 10;
                            break;
                        }
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                        if (!_$error) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 8:
                        sanitizedData = (0,_to_consumable_array/* default */.Z)(data.company);
                        return _ctx.abrupt("return", {
                            data: sanitizedData,
                            message: message
                        });
                    case 10:
                        throw new Error("Attempt to fetch Search company Failed");
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }));
        return function(keyword) {
            return _ref.apply(this, arguments);
        };
    }()),
    getCompanyDetail: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_COMPANY_DETAIL, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(symbol) {
            var response, _data, _$error, message, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return company/* default.getCompanyInfo */.Z.getCompanyInfo(symbol);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to get company detail failed");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            symbol: symbol,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(symbol) {
            return _ref.apply(this, arguments);
        };
    }()),
    getCompanyChart: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_COMPANY_CHART, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var symbol, timeframe, response, _data, _$error, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        symbol = param.symbol, timeframe = param.timeframe;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return company/* default.getCompanyChart */.Z.getCompanyChart(symbol, timeframe);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get company chart failed");
                    case 7:
                        _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            symbol: symbol
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    // Update follow status company, given parameters
    // Watchlist ID, Company ID,
    // and state to be updated (search | suggestion | etc)
    postFollowCompany: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.POST_FOLLOW_COMPANY, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var watchlistId, companyId, _stateToUpdate, stateToUpdate, response, _data, data, message, _$error, sanitizedData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        watchlistId = param.watchlistId, companyId = param.companyId, _stateToUpdate = param.stateToUpdate, stateToUpdate = _stateToUpdate === void 0 ? STATE_SUGGESTION : _stateToUpdate;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return watchlist/* default.postFollowCompany */.Z.postFollowCompany(watchlistId, companyId);
                    case 4:
                        response = _ctx.sent;
                        if (!response.data) {
                            _ctx.next = 11;
                            break;
                        }
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error_type;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        sanitizedData = data[0];
                        return _ctx.abrupt("return", {
                            data: sanitizedData,
                            message: message,
                            stateToUpdate: stateToUpdate
                        });
                    case 11:
                        throw new Error("Attempt to post Follow company Failed");
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    14
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    // Update unfollow status company, given parameters
    // Watchlist ID, Company ID,
    // and state to be updated (search | suggestion | etc)
    postUnfollowCompany: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.POST_UNFOLLOW_COMPANY, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var watchlistId, companyId, _stateToUpdate, stateToUpdate, response, _data, data, message, _$error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        watchlistId = param.watchlistId, companyId = param.companyId, _stateToUpdate = param.stateToUpdate, stateToUpdate = _stateToUpdate === void 0 ? STATE_SUGGESTION : _stateToUpdate;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return watchlist/* default.postUnfollowCompany */.Z.postUnfollowCompany(watchlistId, companyId);
                    case 4:
                        response = _ctx.sent;
                        if (!response.data) {
                            _ctx.next = 10;
                            break;
                        }
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error_type;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            stateToUpdate: stateToUpdate
                        });
                    case 10:
                        throw new Error("Attempt to post Follow company Failed");
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getCompanyContact: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_COMPANY_CONTACT, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(symbol) {
            var response, _data, _$error, message, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return company/* default.getCompanyContact */.Z.getCompanyContact(symbol);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to get company detail failed");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            symbol: symbol,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(symbol) {
            return _ref.apply(this, arguments);
        };
    }()),
    // TODO integrate postFollowUser to watchlist followUser
    postFollowUser: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.FOLLOW_USER, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var username, userid, _type, type, targetAPI, response, _data, _$error, message, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        username = param.username, userid = param.userid, _type = param.type, type = _type === void 0 ? "FOLLOW" : _type;
                        _ctx.prev = 1;
                        if (userid) {
                            _ctx.next = 4;
                            break;
                        }
                        throw new Error("User id is empty");
                    case 4:
                        targetAPI = watchlist/* default.postFollowUser */.Z.postFollowUser;
                        if (type === "UNFOLLOW") {
                            targetAPI = watchlist/* default.postUnfollowUser */.Z.postUnfollowUser;
                        }
                        _ctx.next = 8;
                        return targetAPI(userid);
                    case 8:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 11;
                            break;
                        }
                        throw new Error("Attempt to follow user failed");
                    case 11:
                        _data = response.data, _$error = _data.error_type, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 14;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 14:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            type: type,
                            username: username,
                            userid: userid
                        });
                    case 17:
                        _ctx.prev = 17;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    17
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getBandarDetector: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_BANDAR_DETECTOR, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var symbol, params, response, _data, data, _$error, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        symbol = param.symbol, params = param.params;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return company/* default.getMarketDetector */.Z.getMarketDetector(symbol, params);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get market detector failed!");
                    case 7:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
var reducers = {
    clearSearch: function(state) {
        state.search.data = [];
    }
};
var extraReducers = function(builder) {
    builder.addCase(effects.getSearchCompany.pending, function(state) {
        state.detail.isLoading = true;
        state.detail.error = null;
    }).addCase(effects.getSearchCompany.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error;
        if (error) {
            state.search.error = error;
        } else {
            state.search.data = data;
        }
        state.search.message = message;
        state.search.isLoading = false;
    }).addCase(effects.getSearchCompany.rejected, function(state, action) {
        state.search.error = action.payload.error;
        state.search.isLoading = false;
    }).addCase(effects.getCompanyDetail.pending, function(state) {
        state.detail.isLoading = true;
        state.detail.error = null;
    }).addCase(effects.getCompanyDetail.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data, symbol = _payload.symbol;
        if (error) {
            state.detail.error = error;
        } else {
            state.detail.data[symbol] = data;
            state.detail.error = null;
        }
        state.detail.isLoading = false;
        state.detail.message = message;
    }).addCase(effects.getCompanyDetail.rejected, function(state, action) {
        state.detail.error = action.payload.error;
        state.detail.isLoading = false;
    }).addCase(effects.getCompanyChart.pending, function(state) {
        state.chart.isLoading = true;
        state.chart.error = null;
    }).addCase(effects.getCompanyChart.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data, symbol = _payload.symbol;
        if (error) {
            state.chart.error = error;
        } else {
            // data might be null, e.g. CPO timeframe 1d
            var newData = data ? (0,_object_spread/* default */.Z)({}, data) : null;
            // Inject Previous Price to 'today' prices
            // https://stockbit.atlassian.net/browse/IDT-501
            if (data && data.timeframe === "today" && data.prices.length && data.previous) {
                newData.prices = [
                    {
                        date: "0",
                        formatted_date: "",
                        xlabel: "0",
                        value: data.previous.toString(),
                        percentage: "0.00",
                        change: 0
                    }, 
                ].concat((0,_to_consumable_array/* default */.Z)(data.prices));
            }
            state.chart.data[symbol] = newData;
            state.chart.error = null;
        }
        state.chart.isLoading = false;
        state.chart.message = message;
    }).addCase(effects.getCompanyChart.rejected, function(state, action) {
        state.chart.error = action.payload.error;
        state.chart.isLoading = false;
    }).addCase(effects.postFollowCompany.pending, function(state) {
        state.postFollowCompany.isLoading = true;
        state.postFollowCompany.error = null;
    }).addCase(effects.postFollowCompany.fulfilled, function(state, action) {
        var STATUS_FOLLOWING = 1;
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data, stateToUpdate = _payload.stateToUpdate;
        if (error) {
            state.postFollowCompany.error = error;
        } else {
            state.postFollowCompany.data = data;
            // TODO: Move to new function to wrap this, if allowed
            // update state search
            // find company with `id` == `data.companyId`
            // update followed value to `1`
            var companyid = data.companyid, symbol = data.symbol;
            var newDataState = state.search.data;
            var changedDataIndex = newDataState.findIndex(function(param) {
                var id = param.id;
                return Number(id) === Number(companyid);
            });
            // Do if else to only change specific data state based on
            // flag `stateToUpdate`
            if (stateToUpdate === STATE_SEARCH && changedDataIndex > -1) {
                state.search.data[changedDataIndex].is_following = !!STATUS_FOLLOWING;
            }
            if (stateToUpdate === STATE_DETAIL) {
                state.detail.data[symbol].followed = STATUS_FOLLOWING;
            }
        }
        state.postFollowCompany.message = message;
        state.postFollowCompany.isLoading = false;
    }).addCase(effects.postFollowCompany.rejected, function(state, action) {
        state.postFollowCompany.error = action.payload.error;
        state.postFollowCompany.isLoading = false;
    }).addCase(effects.postUnfollowCompany.pending, function(state) {
        state.postUnfollowCompany.isLoading = true;
        state.postUnfollowCompany.error = null;
    }).addCase(effects.postUnfollowCompany.fulfilled, function(state, action) {
        var STATUS_UNFOLLOWING = 0;
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data, stateToUpdate = _payload.stateToUpdate;
        if (error) {
            state.postUnfollowCompany.error = error;
        } else {
            state.postUnfollowCompany.data = data;
            // TODO: Move this to new function to wrap it, if allowed
            // update state
            // find company with `id` == `data.companyId`
            // update followed value to `1`
            var companyid = data.companyid, symbol = data.symbol;
            var newDataState = state.search.data;
            var changedDataIndex = newDataState.findIndex(function(param) {
                var id = param.id;
                return Number(id) === Number(companyid);
            });
            if (stateToUpdate === STATE_SEARCH && changedDataIndex > -1) {
                state.search.data[changedDataIndex].is_following = !!STATUS_UNFOLLOWING;
            }
            if (stateToUpdate === STATE_DETAIL) {
                state.detail.data[symbol].followed = STATUS_UNFOLLOWING;
            }
        }
        state.postUnfollowCompany.message = message;
        state.postUnfollowCompany.isLoading = false;
    }).addCase(effects.postUnfollowCompany.rejected, function(state, action) {
        state.postUnfollowCompany.error = action.payload.error;
        state.postUnfollowCompany.isLoading = false;
    }).addCase(effects.getCompanyContact.pending, function(state) {
        state.contact.isLoading = true;
        state.contact.error = null;
    }).addCase(effects.getCompanyContact.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data, symbol = _payload.symbol;
        if (error) {
            state.contact.error = error;
        } else {
            state.contact.data[symbol] = data;
            state.contact.error = null;
        }
        state.contact.isLoading = false;
        state.contact.message = message;
    }).addCase(effects.getCompanyContact.rejected, function(state, action) {
        state.contact.error = action.payload.error;
        state.contact.isLoading = false;
    }).addCase(effects.postFollowUser.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error, userid = _payload.userid, type = _payload.type, symbol = _payload.username;
        if (!error) {
            var activeSymbol = state.contact.data[symbol];
            if (activeSymbol) {
                var idx = activeSymbol.findIndex(function(item) {
                    return item.id === userid;
                });
                if (idx !== -1) {
                    var FOLLOWING = type === "FOLLOW" ? 1 : 0;
                    // If follow specific child, also add following to all watchlist
                    // Update the selected wathclist item
                    state.contact.data[symbol][idx].is_followed = FOLLOWING;
                }
            }
        }
    }).addCase(effects.getBandarDetector.pending, function(state) {
        state.brokerSummary.isLoading = true;
        state.brokerSummary.error = null;
    }).addCase(effects.getBandarDetector.fulfilled, function(state, action) {
        var _payload = action.payload, _data = _payload.data, data = _data === void 0 ? {} : _data, error = _payload.error, message = _payload.message;
        if (error) {
            state.brokerSummary.error = error;
        }
        if (!data.bandar_detector || !data.broker_summary) {
            state.brokerSummary.data.detector = {};
            state.brokerSummary.data.summary = defaultSummary;
            state.brokerSummary.data.from = "";
            state.brokerSummary.data.to = "";
            state.brokerSummary.error = null;
        }
        if (data.bandar_detector && data.broker_summary) {
            state.brokerSummary.data.detector = data.bandar_detector;
            state.brokerSummary.data.summary = data.broker_summary;
            state.brokerSummary.data.from = data.from;
            state.brokerSummary.data.to = data.to;
            state.brokerSummary.error = null;
        }
        state.brokerSummary.message = message;
        state.brokerSummary.isLoading = false;
    }).addCase(effects.getBandarDetector.rejected, function(state, action) {
        state.brokerSummary.error = action.payload.error;
        state.brokerSummary.isLoading = false;
    });
};
// Create redux slice
var companySlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "company",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ var entities_company = (companySlice);


/***/ }),

/***/ 333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ profile; },
  "Sz": function() { return /* binding */ effects; },
  "Cr": function() { return /* binding */ proExpirySelector; },
  "Rd": function() { return /* binding */ profileSelector; },
  "wl": function() { return /* binding */ selectors; }
});

// UNUSED EXPORTS: initialState, userIdSelector

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(61876);
// EXTERNAL MODULE: ./src/lib/api/user.ts
var user = __webpack_require__(1955);
// EXTERNAL MODULE: ./src/lib/api/verifiedBadge.ts
var verifiedBadge = __webpack_require__(79644);
// EXTERNAL MODULE: ./src/utils/auth.js
var auth = __webpack_require__(14229);
// EXTERNAL MODULE: ./src/utils/clevertap.js
var clevertap = __webpack_require__(48028);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
;// CONCATENATED MODULE: ./src/lib/models/user/index.js

var schema = {
    id: "",
    username: "",
    fullname: "",
    email: "",
    activated: "",
    banned: "0",
    user_banned_until: "",
    ban_reason: null,
    last_login: "",
    created: "",
    modified: "",
    avatar: "",
    about: "",
    location: "",
    website: "",
    occupation: "",
    gender: "",
    birthday: "",
    phone: "",
    address: "",
    hide_email: "0",
    user_attr: "",
    user_priv: "0",
    tutorial: "0",
    user_newsletter: "",
    country: "",
    exchange: "",
    facebook_id: null,
    apple_id: null,
    google_id: null,
    email_subscribe: "",
    user_phone_verification: "",
    facebook_hide: "",
    language: "",
    user_preferences: {},
    user_trading: "",
    user_badge_top: "",
    followed: 0,
    ispro: 0,
    pro_active_since: "",
    pro_expire_at: "",
    tradingpro: 0,
    official: 0,
    trending: 0,
    ir_symbol: "",
    isblocked: 0,
    alert: 0,
    onboarding: 0,
    onboarding_done: 0,
    discover: 0,
    ftcode: "",
    ftend: "",
    realtrading_access: 0,
    top_badge: 0,
    is_term_agreed: 0,
    onesignal_hash: "",
    password: 0,
    support: {
        id: ""
    }
};
var propTypes = {
    id: prop_types.string,
    username: prop_types.string,
    fullname: prop_types.string,
    email: prop_types.string,
    activated: prop_types.string,
    banned: prop_types.string,
    user_banned_until: prop_types.string,
    ban_reason: prop_types.string,
    last_login: prop_types.string,
    created: prop_types.string,
    modified: prop_types.string,
    avatar: prop_types.string,
    about: prop_types.string,
    location: prop_types.string,
    website: prop_types.string,
    occupation: prop_types.string,
    gender: prop_types.string,
    birthday: prop_types.string,
    phone: prop_types.string,
    address: prop_types.string,
    user_attr: prop_types.string,
    user_newsletter: prop_types.string,
    country: prop_types.string,
    exchange: prop_types.string,
    hide_email: prop_types.string,
    user_priv: prop_types.string,
    tutorial: prop_types.string,
    facebook_id: prop_types.string,
    apple_id: prop_types.string,
    google_id: prop_types.string,
    email_subscribe: prop_types.string,
    user_phone_verification: prop_types.string,
    facebook_hide: prop_types.string,
    language: prop_types.string,
    user_preferences: (0,prop_types.oneOfType)([
        prop_types.object,
        prop_types.any
    ]),
    user_trading: prop_types.string,
    user_badge_top: prop_types.string,
    followed: prop_types.number,
    ispro: prop_types.number,
    pro_active_since: prop_types.string,
    pro_expire_at: prop_types.string,
    tradingpro: prop_types.number,
    official: prop_types.number,
    trending: prop_types.number,
    ir_symbol: prop_types.string,
    isblocked: prop_types.number,
    alert: prop_types.number,
    onboarding: prop_types.number,
    onboarding_done: prop_types.number,
    discover: prop_types.number,
    ftcode: prop_types.string,
    ftend: prop_types.string,
    onesignal_hash: prop_types.string,
    realtrading_access: prop_types.number,
    top_badge: prop_types.number,
    is_term_agreed: prop_types.number,
    password: prop_types.number
};
/* harmony default export */ var models_user = ({
    schema: schema,
    propTypes: propTypes
});

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./src/utils/userResponseMapping.ts



var formatDate = function(date) {
    return moment_default()(date).format("YYYY-MM-DD HH:mm:ss");
};
var userResponseMapping = function(data) {
    var id = data.id, created_at = data.created_at, statistics = data.statistics, profile = data.profile, privilege = data.privilege, exchange = data.exchange, ir_symbols = data.ir_symbols, badges = data.badges, is_alert_enabled = data.is_alert_enabled, is_blocked = data.is_blocked, is_followed = data.is_followed, email = data.email, last_modified_at = data.last_modified_at, last_login_at = data.last_login_at, is_activated = data.is_activated, has_password = data.has_password, is_newsletter_subscriber = data.is_newsletter_subscriber, is_phone_verified = data.is_phone_verified, is_shown_in_discovery = data.is_shown_in_discovery, preferences = data.preferences, onboarding = data.onboarding, free_trial = data.free_trial, sns = data.sns, trading = data.trading, support = data.support, pro = data.pro, ban = data.ban, onesignal_hash = data.onesignal_hash;
    var follower_count = statistics.follower_count, following_count = statistics.following_count, reputation_count = statistics.reputation_count, idea_count = statistics.idea_count, like_count = statistics.like_count, view_count = statistics.view_count;
    var username = profile.username, fullname = profile.fullname, about = profile.about, website = profile.website, avatar = profile.avatar, country = profile.country, language = profile.language, gender = profile.gender, location = profile.location, address = profile.address, birthday = profile.birthday, phone = profile.phone, occupation = profile.occupation;
    var result = {
        id: String(id),
        username: username,
        fullname: fullname,
        email: email,
        activated: is_activated ? "1" : "0",
        banned: String(ban.code),
        user_banned_until: formatDate(ban.until),
        ban_reason: ban.reason === "" ? null : ban.reason,
        last_login: formatDate(last_login_at),
        created: formatDate(created_at),
        modified: formatDate(last_modified_at),
        avatar: avatar.default,
        about: about,
        location: location,
        website: website,
        occupation: occupation,
        gender: gender,
        birthday: birthday,
        phone: phone.formatted,
        address: address,
        hide_email: preferences.privacy.is_hide_email ? "1" : "0",
        // user_attr
        user_priv: String(privilege.code),
        // tutorial
        // user_newsletter
        country: country,
        exchange: exchange,
        facebook_id: sns.facebook_id,
        apple_id: sns.apple_id,
        google_id: sns.google_id,
        email_subscribe: is_newsletter_subscriber ? "1" : "0",
        user_phone_verification: is_phone_verified ? "1" : "0",
        facebook_hide: preferences.privacy.is_hide_facebook ? "1" : "0",
        language: language,
        user_preferences: {
            stream_version: preferences.stream.version
        },
        user_trading: String(trading.account_id),
        // user_badge_top
        additional: {
            reputations: reputation_count,
            followers: String(follower_count),
            ideas: String(idea_count),
            following: String(following_count),
            likes: like_count,
            views: view_count
        },
        followed: is_followed ? 1 : 0,
        ispro: trading.is_pro || pro.is_pro || !moment_default()().isAfter(free_trial.expired_at) ? 1 : 0,
        pro_active_since: formatDate(pro.active_since),
        pro_expire_at: formatDate(pro.expired_at),
        tradingpro: trading.is_pro ? 1 : 0,
        // official
        trending: badges.is_trending ? 1 : 0,
        ir_symbol: ir_symbols,
        isblocked: is_blocked ? 1 : 0,
        alert: is_alert_enabled ? 1 : 0,
        onboarding: onboarding.current_step,
        onboarding_done: onboarding.is_done ? 1 : 0,
        discover: is_shown_in_discovery ? 1 : 0,
        ftcode: free_trial.code,
        ftend: formatDate(free_trial.expired_at),
        realtrading_access: trading.has_realtrading_access ? 1 : 0,
        top_badge: badges.is_top ? 1 : 0,
        // is_term_agreed
        intercom: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, support.intercom), {
            email: support.intercom.email,
            created_at: support.intercom.created_at,
            phone: support.intercom.phone
        }),
        password: has_password ? 1 : 0,
        onesignal_hash: onesignal_hash,
        support: {
            id: support.id
        }
    };
    return result;
};

// EXTERNAL MODULE: ./src/utils/logger.ts
var logger = __webpack_require__(91635);
;// CONCATENATED MODULE: ./src/lib/entities/profile.js







// api
// import { AWS_AVATAR_BUCKET } from 'constants/api';


// Utils


// model



// initial state
var initialState = {
    data: models_user.schema,
    isLoading: true,
    error: null,
    message: "",
    // for flagging btn back is clicked
    isClickedPreviousButton: false,
    connectSocialMedia: {
        data: {},
        isLoading: true,
        error: null,
        message: ""
    }
};
// Selectors -------------------------------------------------------------------
var selectors = (0,es/* createSelector */.P1)(function(state) {
    return state.entities.profile;
}, function(state) {
    return {
        data: state.data,
        isLoading: state.isLoading,
        error: state.error,
        message: state.message,
        isClickedPreviousButton: state.isClickedPreviousButton,
        connectSocialMedia: state.connectSocialMedia
    };
});
var profileSelector = (0,es/* createSelector */.P1)(function(state) {
    return state.entities.profile.data;
}, function(data) {
    return data;
});
var proExpirySelector = (0,es/* createSelector */.P1)(function(state) {
    return state.entities.profile.data;
}, function(data) {
    return data.pro_expire_at;
});
var userIdSelector = (0,es/* createSelector */.P1)(function(state) {
    return state.entities.profile.data.id;
}, function(id) {
    return id;
});
// Actions ---------------------------------------------------------------------
// types
var CONTEXT = "@redux/user";
var actionType = {
    FETCH_PROFILE: "".concat(CONTEXT, "/FETCH_PROFILE"),
    UPDATE_PROFILE: "".concat(CONTEXT, "/UPDATE_PROFILE"),
    CONNECT_SOCIAL_MEDIA: "".concat(CONTEXT, "/CONNECT_SOCIAL_MEDIA"),
    UPDATE_PREFERENCE: "".concat(CONTEXT, "/UPDATE_PREFERENCE")
};
// effects
var effects = {
    // getTrendinguser -------------------------------------------------------------------
    getUserProfile: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.FETCH_PROFILE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(username) {
            var response, _data, data, message, _$error, userId, _$username, email, avatar, responseGetVerifiedBadge, mappedData, isEmitenUser;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return user/* default.getUserProfile */.Z.getUserProfile(username);
                    case 3:
                        response = _ctx.sent;
                        if (!response.data) {
                            _ctx.next = 18;
                            break;
                        }
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                        userId = data.id ? Number(data.id) : 0;
                        _$username = data.profile && data.profile.username || "";
                        email = data.email || "";
                        avatar = data.profile && data.profile.avatar && data.profile.avatar.default || "";
                        _ctx.next = 12;
                        return verifiedBadge/* default.getVerifiedBadgeUser */.Z.getVerifiedBadgeUser(userId);
                    case 12:
                        responseGetVerifiedBadge = _ctx.sent;
                        if (!_$error) {
                            _ctx.next = 15;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 15:
                        mappedData = userResponseMapping(data);
                        // Clevertap pprofile initialization
                        if (responseGetVerifiedBadge && responseGetVerifiedBadge.data) {
                            isEmitenUser = responseGetVerifiedBadge.data && responseGetVerifiedBadge.data.is_emitten || false;
                            // Track if username is empty
                            if (!_$username) {
                                (0,logger/* default */.ZP)(new Error("[CT initialization Error]: username is empty"), {
                                    place: "src/lib/entities/profile.js",
                                    event: "getUserProfile",
                                    eventParam: {
                                        profile: data.profile
                                    }
                                });
                            }
                            (0,clevertap/* clevertapProfilingUser */.$b)({
                                isInitProfile: true,
                                identity: _$username,
                                email: email,
                                profilePictureUrl: avatar,
                                isEmitenUser: isEmitenUser
                            });
                        }
                        return _ctx.abrupt("return", {
                            data: mappedData,
                            message: message
                        });
                    case 18:
                        throw new Error("Attempt to fetch Trending user Failed");
                    case 21:
                        _ctx.prev = 21;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 24:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    21
                ]
            ]);
        }));
        return function(username) {
            return _ref.apply(this, arguments);
        };
    }()),
    // editUserProfile -------------------------------------------------------------------
    editUserProfile: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.UPDATE_PROFILE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(requestBody) {
            var preventUpdate, body, response, _data, data, message, _$error, sanitizedData, mappedData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        preventUpdate = requestBody.preventUpdate, body = (0,_object_without_properties/* default */.Z)(requestBody, [
                            "preventUpdate"
                        ]);
                        _ctx.next = 4;
                        return user/* default.editUserProfile */.Z.editUserProfile(body);
                    case 4:
                        response = _ctx.sent;
                        if (!response.data) {
                            _ctx.next = 12;
                            break;
                        }
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 9:
                        sanitizedData = (0,_object_spread/* default */.Z)({}, data);
                        mappedData = userResponseMapping(data);
                        return _ctx.abrupt("return", {
                            data: mappedData,
                            message: message,
                            preventUpdate: preventUpdate
                        });
                    case 12:
                        throw new Error("Attempt to fetch Trending user Failed");
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    15
                ]
            ]);
        }));
        return function(requestBody) {
            return _ref.apply(this, arguments);
        };
    }()),
    // userConnectSocialMedia -------------------------------------------------------------------
    userConnectSocialMedia: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.CONNECT_SOCIAL_MEDIA, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param, param1) {
            var socialMediaName, requestBody, dispatch, response, _data, data, message, _$error, userAccess, usernameAuth;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        socialMediaName = param.socialMediaName, requestBody = param.requestBody, dispatch = param1.dispatch;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return user/* default.userConnectSocialMedia */.Z.userConnectSocialMedia(socialMediaName, requestBody);
                    case 4:
                        response = _ctx.sent;
                        if (!response.data) {
                            _ctx.next = 13;
                            break;
                        }
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 9:
                        userAccess = auth/* default.getUserAccess */.Z.getUserAccess();
                        usernameAuth = userAccess.username;
                        dispatch(effects.getUserProfile(usernameAuth));
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        throw new Error("Attempt to connect social media Failed");
                    case 16:
                        _ctx.prev = 16;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    16
                ]
            ]);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }()),
    updatePreference: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.UPDATE_PREFERENCE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(requestData) {
            var response, _data, data, error, error_type, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return user/* default.updatePreference */.Z.updatePreference(requestData);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt update preference failed");
                    case 6:
                        _data = response.data, data = _data.data, error = _data.error, error_type = _data.error_type, message = _data.message;
                        if (!(error || error_type)) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(message);
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(requestData) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducer ---------------------------------------------------------------------
var reducers = {
    /**
   * updateOnboardingStep
   * Store back onboarding progress step
   * @param step - object of previous progress step
   * @param isClickedPreviousButton - boolean
   */ updateOnboardingStep: function(draft, action) {
        var step = action.payload.step;
        var newData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, draft.data), {
            onboarding: step
        });
        draft.data = newData;
    },
    /**
   * resetIsClickedPreviousButton
   * change isClickedPreviousButton to false
   */ resetIsClickedPreviousButton: function(draft) {
        draft.isClickedPreviousButton = false;
    },
    /**
   * reset profile state
   */ resetProfileState: function(draft) {
        draft.data = models_user.schema;
    }
};
var _obj;
// Extra Reducer ---------------------------------------------------------------
var extraReducers = (_obj = {}, // Get Userprofile -----------------------------------------------------------
(0,_define_property/* default */.Z)(_obj, effects.getUserProfile.pending, function(state) {
    state.isLoading = true;
}), (0,_define_property/* default */.Z)(_obj, effects.getUserProfile.fulfilled, function(state, action) {
    var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error;
    if (error) {
        state.error = error;
    } else {
        state.data = data;
    }
    state.message = message;
    state.isLoading = false;
}), (0,_define_property/* default */.Z)(_obj, effects.getUserProfile.rejected, function(state, action) {
    state.error = action.payload.error;
    state.isLoading = false;
}), // Post editUserProfile -----------------------------------------------------------
// replace state profile
(0,_define_property/* default */.Z)(_obj, effects.editUserProfile.pending, function(state) {
    state.isLoading = true;
}), (0,_define_property/* default */.Z)(_obj, effects.editUserProfile.fulfilled, function(state, action) {
    var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error, preventUpdate = _payload.preventUpdate;
    if (error) {
        state.error = error;
    } else {
        // to handle when user has clicked previous button
        // used last onboarding step from state
        // to be used in button next
        var isClickedPreviousButton = state.isClickedPreviousButton;
        var _data = state.data, lastProgress = _data.onboarding;
        var newDataWithLastProgress = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.data), {
            onboarding: lastProgress
        });
        if (!preventUpdate) {
            state.data = isClickedPreviousButton ? newDataWithLastProgress : data;
        }
    }
    state.message = message;
    state.isLoading = false;
}), (0,_define_property/* default */.Z)(_obj, effects.editUserProfile.rejected, function(state, action) {
    state.error = action.payload.error;
    state.isLoading = false;
}), // Post userConnectSocialMedia -----------------------------------------------------------
(0,_define_property/* default */.Z)(_obj, effects.userConnectSocialMedia.pending, function(state) {
    state.connectSocialMedia.isLoading = true;
}), (0,_define_property/* default */.Z)(_obj, effects.userConnectSocialMedia.fulfilled, function(state, action) {
    var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error;
    if (error) {
        state.connectSocialMedia.error = error;
    } else {
        state.connectSocialMedia.data = data;
    }
    state.connectSocialMedia.message = message;
    state.connectSocialMedia.isLoading = false;
}), (0,_define_property/* default */.Z)(_obj, effects.userConnectSocialMedia.rejected, function(state, action) {
    state.connectSocialMedia.error = action.payload.error;
    state.connectSocialMedia.isLoading = false;
}), _obj);
// Slice -----------------------------------------------------------------------
var profileSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "profile",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ var profile = (profileSlice);


/***/ }),

/***/ 7639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ stores_useUIConfigStore; }
});

// UNUSED EXPORTS: resetRules

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./node_modules/zustand/esm/middleware.js
var middleware = __webpack_require__(38597);
// EXTERNAL MODULE: ./src/utils/auth.js
var auth = __webpack_require__(14229);
// EXTERNAL MODULE: ./src/typings/auth.ts
var typings_auth = __webpack_require__(97718);
;// CONCATENATED MODULE: ./src/utils/objectOperations.ts

var pickObject = function(obj, keys) {
    var pickedObject = {};
    keys.forEach(function(key) {
        pickedObject[key] = obj === null || obj === void 0 ? void 0 : obj[key];
    });
    return pickedObject;
};
var omitObject = function(obj, keys) {
    var omittedObject = (0,_object_spread/* default */.Z)({}, obj);
    keys.forEach(function(key) {
        return delete omittedObject[key];
    });
    return omittedObject;
};

;// CONCATENATED MODULE: ./src/stores/useUIConfigStore/index.ts









var _obj;
var resetRules = (_obj = {}, // List item that should not deleted on social logout
(0,_define_property/* default */.Z)(_obj, typings_auth/* LoginType.Social */.B.Social, [
    "tradingLimitTooltip",
    "tradingLimitTnc",
    // Day Trade
    "dayTradeTnc",
    "dayTradeTncShown", 
]), // List item that should be deleted on securities logout
(0,_define_property/* default */.Z)(_obj, typings_auth/* LoginType.Securities */.B.Securities, [
    "featureFlags"
]), _obj);
var initialState = {
    userConfig: {}
};
var useUIConfigStore = (0,esm/* default */.ZP)((0,middleware/* persist */.tJ)(function(set, get) {
    var ref, ref1, ref2;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        setUIValue: function(key, value) {
            var userId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (ref = auth/* default.getUserAccess */.Z.getUserAccess()) === null || ref === void 0 ? void 0 : ref.id;
            set((0,immer_esm/* default */.ZP)(function(state) {
                if (!state.userConfig[userId]) state.userConfig[userId] = {};
                if (typeof value === "function") {
                    if (!state.userConfig[userId][key]) {
                        state.userConfig[userId] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.userConfig[userId]), (0,_define_property/* default */.Z)({}, key, {}));
                    }
                    value(state.userConfig[userId][key]);
                    return;
                }
                state.userConfig[userId][key] = value;
            }));
        },
        getUIValue: function(key) {
            var userId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (ref1 = auth/* default.getUserAccess */.Z.getUserAccess()) === null || ref1 === void 0 ? void 0 : ref1.id;
            var ref;
            return (ref = get().userConfig[userId]) === null || ref === void 0 ? void 0 : ref[key];
        },
        resetUIValue: function(loginType) {
            var userId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (ref2 = auth/* default.getUserAccess */.Z.getUserAccess()) === null || ref2 === void 0 ? void 0 : ref2.id;
            var resetSocial = function() {
                set((0,immer_esm/* default */.ZP)(function(state) {
                    state.userConfig[userId] = pickObject(state.userConfig[userId], resetRules[typings_auth/* LoginType.Social */.B.Social]);
                }));
            };
            var resetSecurities = function() {
                set((0,immer_esm/* default */.ZP)(function(state) {
                    state.userConfig[userId] = omitObject(state.userConfig[userId], resetRules[typings_auth/* LoginType.Securities */.B.Securities]);
                }));
            };
            var _obj;
            var resetActions = (_obj = {}, (0,_define_property/* default */.Z)(_obj, typings_auth/* LoginType.Social */.B.Social, resetSocial), (0,_define_property/* default */.Z)(_obj, typings_auth/* LoginType.Securities */.B.Securities, resetSecurities), _obj);
            resetActions[loginType]();
        }
    });
}, {
    name: "UIConfigStore"
}));
/* harmony default export */ var stores_useUIConfigStore = (useUIConfigStore);


/***/ }),

/***/ 97718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ LoginType; },
/* harmony export */   "z": function() { return /* binding */ OtpChannel; }
/* harmony export */ });
var LoginType;
(function(LoginType) {
    LoginType["Social"] = "social";
    LoginType["Securities"] = "securities";
})(LoginType || (LoginType = {}));
var OtpChannel;
(function(OtpChannel) {
    OtpChannel["Unspecified"] = "CHANNEL_UNSPECIFIED";
    OtpChannel["Sms"] = "CHANNEL_SMS";
    OtpChannel["WhatsApp"] = "CHANNEL_WHATSAPP";
})(OtpChannel || (OtpChannel = {}));


/***/ }),

/***/ 14601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HM": function() { return /* binding */ isReadMoreShow; },
/* harmony export */   "Hm": function() { return /* binding */ cleanupStreamPayload; },
/* harmony export */   "Nk": function() { return /* binding */ parseExistImage; },
/* harmony export */   "P9": function() { return /* binding */ getYoutubeVideoId; },
/* harmony export */   "PI": function() { return /* binding */ transformConversationV3; },
/* harmony export */   "Zu": function() { return /* binding */ getYoutubeURL; },
/* harmony export */   "bv": function() { return /* binding */ transformV3Response; },
/* harmony export */   "hp": function() { return /* binding */ transformStreamV3; },
/* harmony export */   "qm": function() { return /* binding */ parseEmoji; },
/* harmony export */   "vO": function() { return /* binding */ parseStreamPostContent; }
/* harmony export */ });
/* unused harmony export countWords */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36305);
/* harmony import */ var global_StreamCompose_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79030);
/* eslint-disable prefer-destructuring */ /* eslint-disable no-useless-escape */ /* eslint-disable import/prefer-default-export */ 




/**
 * Function to parse post content to data which can be read in
 * component `StreamCompose`
 * @param {Object} post - Post object
 * @return {Object} parsed post
 */ var parseEmoji = function(textContent) {
    return textContent;
};
var parseStreamPostContent = function(post) {
    var content = post.content_original, images = post.images, imagesData = post.images_data, attachment = post.attachment, targetPrice = post.target_price, commenterType = post.commenter_type, postId = post.postid, parentPostId = post.parent_postid;
    var parsedContent = {
        content: parseEmoji(content),
        images: images,
        images_data: imagesData,
        documents: attachment || [],
        targetPrice: null,
        commenter_type: commenterType,
        postId: postId,
        parentPostId: parentPostId
    };
    if ((targetPrice === null || targetPrice === void 0 ? void 0 : targetPrice.length) > 0) {
        parsedContent.targetPrice = {
            target_duration: targetPrice[0].duration,
            target_price: targetPrice[0].target_price,
            target_symbol: targetPrice[0].symbol
        };
    }
    // Polling is not included to parsed content since polling is not editable
    return parsedContent;
};
/**
 * Get last Youtube url from user content
 * @param {string} contentOriginal - original content from stream post
 */ function getYoutubeURL() {
    var contentOriginal = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var exp = /((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?/gm;
    var list = contentOriginal.match(exp);
    if (list && list.length >= 1) {
        return list[list.length - 1];
    }
    return null;
}
/**
 * parse youtube video URL
 * @param {string} youtubeURL - URL of youtube video
 */ function parseYoutubeURL() {
    var youtubeURL = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var exp = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]{1,50}\?v=|embed\/|v\/|e\/|live\/|shorts\/)?)([\w\-]{11})(\S+)?$/gm;
    var list = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(youtubeURL.matchAll(exp)).map(function(m) {
        return {
            url: m[0],
            protocol: m[1],
            www: m[2],
            host: m[3],
            slug: m[4],
            id: m[5],
            params: m[6]
        };
    });
    return list.length === 1 ? list[0] : null;
}
/**
 * Get youtube video ID from youtube URL
 * @param {string} youtubeURL - URL of youtube video
 */ function getYoutubeVideoId() {
    var youtubeURL = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var ref;
    return youtubeURL ? (ref = parseYoutubeURL(youtubeURL)) === null || ref === void 0 ? void 0 : ref.id : null;
}
/**
 * Count words from escaped string
 * @param {string} str
 * @returns {number} words length
 */ var countWords = function(str) {
    var newStr = str.trim();
    newStr = newStr.replace(/[ ]{2,}/gi, " ");
    newStr = newStr.replace(/\n /, "\n");
    return newStr.split(/\s+/).length;
};
var MAX_WORDS = 10;
var MAX_NEWLINE = 2;
/**
 * Decide to show read more flag
 * @param {string} contentOriginal - Original content
 * @param {number=} maxWords - Maximum words
 * @param {number=} maxNewLine - Max paragraph
 * @returns {boolean}
 */ var isReadMoreShow = function() {
    var contentOriginal = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", maxWords = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : MAX_WORDS, maxNewLine = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : MAX_NEWLINE;
    return countWords(contentOriginal) > maxWords || contentOriginal.split(/\r\n|\r|\n/).length > maxNewLine;
};
/**
 * Parse Etension from Url
 * @param {string} unparsedUrl - url file string
 * @returns {string} - file extension from the url
 */ var parseExtension = function(unparsedUrl) {
    // Remove everything to the last slash in URL
    var url = unparsedUrl.substr(1 + unparsedUrl.lastIndexOf("/"));
    // Break URL at ? and take first part (file name, extension)
    url = url.split("?")[0];
    // Sometimes URL doesn't have ? but #, so we should aslo do the same for #
    url = url.split("#")[0];
    // Now we have only extension
    url = url.split(".").pop();
    return url;
};
/**
 * Parse Images Data Json to parsed Format
 * @param {Array} images - images_data JSON response from api
 * @returns {Array}
 */ var parseExistImage = function(images) {
    var parsedImages = images.map(function(image) {
        return {
            dimensions: {
                width: image.width,
                height: image.height
            },
            imagePreviewUrl: image.image,
            file: image.image,
            isNew: false,
            type: parseExtension(image.image).toLowerCase() === "gif" ? global_StreamCompose_constants__WEBPACK_IMPORTED_MODULE_0__/* .IMAGE_TYPE_GIF */ .p$ : global_StreamCompose_constants__WEBPACK_IMPORTED_MODULE_0__/* .IMAGE_TYPE_COMMON */ .EZ
        };
    });
    return parsedImages;
};
/**
 * Convert stream V3 response to stream V2 response
 * @param {Object} stream - stream V3 response
 * @returns {Object} stream V2 response
 */ function transformStreamV3() {
    var stream = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref, ref1;
    if (!stream) {
        return stream;
    }
    var UserRole = {
        PRIVILEGE_MEMBER: 0,
        PRIVILEGE_ADMIN: 1,
        PRIVILEGE_MODERATOR: 2,
        PRIVILEGE_CONFIGURATOR: 3,
        PRIVILEGE_SUPER_ADMIN: 4
    };
    var CountryID = {
        COUNTRY_ID: "ID",
        COUNTRY_MY: "MY",
        COUNTRY_SG: "SG"
    };
    var transformBoolean = function(status) {
        return status ? 1 : 0;
    };
    var transformed = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, stream, stream.status, stream.user), {
        country: CountryID[stream.user.country],
        created: stream.created_at,
        follow: transformBoolean(stream.status.is_followed),
        is_author: transformBoolean(stream.user.is_author),
        is_unavailable: stream.status.is_unavailable,
        isnews: transformBoolean(stream.title_url),
        ispinned: transformBoolean(stream.status.is_pinned),
        ispro: transformBoolean(stream.user.is_pro),
        liked: transformBoolean(stream.status.is_liked),
        likes: stream.total_likes,
        newsfeed_img: stream.news_feed.img,
        newsfeed_label: stream.news_feed.label,
        newsfeed_source: stream.news_feed.source,
        official: transformBoolean(stream.user.is_verified),
        parent_postid: stream.parent_stream_id,
        postid: stream.stream_id,
        replies: stream.total_replies.toString(),
        replying_to: transformBoolean(stream.reply_to),
        replyto: stream.reply_to.toString(),
        reposted: transformBoolean(stream.status.is_reposted),
        repostedfrom: transformStreamV3(stream.reposted_from),
        saved: transformBoolean(stream.status.is_saved),
        titleurl: stream.title_url,
        trending: transformBoolean(stream.status.is_trending),
        updated: stream.updated_at,
        user_priv: UserRole[stream.user.user_privilege],
        userid: stream.user.user_id,
        isJunk: Boolean((ref = stream.status) === null || ref === void 0 ? void 0 : ref.is_junk),
        isSpam: Boolean((ref1 = stream.status) === null || ref1 === void 0 ? void 0 : ref1.is_spam)
    });
    if (transformed.last_reply && transformed.last_reply.user) {
        transformed.last_reply = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, transformed.last_reply, transformed.last_reply.user), {
            postid: transformed.last_reply.stream_id
        });
        delete transformed.last_reply.user;
    }
    if (transformed.reply_content) {
        transformed.reply_content = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, transformed.reply_content), {
            titleurl: transformed.reply_content.title_url
        });
        delete transformed.reply_content.title_url;
    }
    delete transformed.user;
    delete transformed.status;
    return transformed;
}
/**
 * Convert stream V3 response to stream V2 response
 * @param {Array} streamList - stream V3 response
 * @returns {Array} stream V2 response
 */ function transformV3Response() {
    var streamList = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (!streamList) {
        return streamList;
    }
    return streamList.map(transformStreamV3);
}
function transformConversationV3() {
    var conversation = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!conversation) {
        return conversation;
    }
    var payload = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, conversation), {
        parent: transformStreamV3(conversation.parent),
        replies: transformV3Response(conversation.replies)
    });
    return payload;
}
/**
 * Remove empty value from object
 * @param {Object} obj
 * @returns {Object}
 * @example
 * const obj = {
 *  a: '',
 * b: null,
 * c: undefined,
 * d: 'd',
 * }
 * cleanupStreamPayload(obj) // { d: 'd' }
 */ function cleanupStreamPayload(obj) {
    return Object.fromEntries(Object.entries(obj).filter(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(param, 2), value = _param[1];
        return value !== "" && value !== null && value !== undefined;
    }));
}



/***/ })

}]);